import { Add, AutoAwesome, Delete, FileCopy } from '@mui/icons-material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Button, Checkbox, FormControl, FormControlLabel, IconButton, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { styled as muiStyled } from '@mui/material/styles';
import * as Sentry from '@sentry/react';
import { Col, Drawer, Modal, Row } from 'antd';
import Acent from 'components/Acent';
import AudioMultipleChoice from 'components/AdminBooks/AudioWithMultichoice';
import AudioWithEssay from 'modules/activityModule/audioWithWrittenResponse/AudioWithEssay';
import MatchMaking from 'components/AdminBooks/PageToolbarModals/MatchMaking';
import PictureAssignment from 'components/Image/PictureAssignment';
import Loading from 'components/Loading';
import TextEditor from 'components/TextEditor';
import { useAlertLoading } from 'components/UI/alertSakeBar/alertProvider';
import useOrientationFullScreen from 'components/hooks/useOrientationFullScreen';
import { useTabletDetection } from 'containers/chat/hooks';
import AudioRecorder from 'features/AudeoRecorderNew';
import { cloneDeep, filter, find, get, has, map } from "lodash";
import AssignmentPhotoCollage from 'modules/activityModule/photoCollage';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { handleCreateCustomAssignment, handleGetAssignmentStatus, handleUpdateCustomAssignment } from "store/activities/thunks";
import { useAllBook } from 'store/books/selectors';
import { useClassActivities } from 'store/classActivities/selectors';
import { useClassQuizzes } from 'store/classQuizzes/selectors';
import { useResources } from 'store/resources/selectors';
import { handleAudioTranscript } from 'store/submissions/thunks';
import { useUserClasses } from 'store/userClasses/selectors';
import { handleGetAiOptionForAnswer } from 'store/vocabulary/thunks';
import styled from 'styled-components';
import { SoyStoryImg, SoyHistoriasNew } from 'utils/assets/images';
import { DURATIONS, imageUpload, photoCollageData, QUESTION_TYPE_ACTIVITY_NON_NATIVE } from 'utils/config/reference';
import COLOR from 'utils/constants/color';
import { imageFetchDinamic, imageFetchFromPodcast, getBookContent, removeQuestionError } from 'utils/lib/ebookHelper';
import { disableBodyScroll, filterDuplicateWords, removeCustomDuplicates } from 'utils/methods/math';
import AudioPicker from "./AudioPicker";
import { AssignmentFormFillInBlanksComp, AssignmentVideo } from './assignment';
import { validateMatchMaking } from './assignment/studentMatchMaking/helper';
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import { useAssignmentCoverTitle } from 'components/hooks/pageCover/useAssignmentCoverTitle';
import PictureAssignmentType from './assignment/picture';
import { useStandardExams } from 'store/standardexams';
import { useExams } from 'store/exams/selectors';
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import { checkStandardExam } from 'utils/methods/textMethod';
import AssignmentAiSection from 'components/AssignmentAiGenerate/AssignmentAiModal';
import { useBookUnits } from 'store/booksUnits/selectors';
import { usePageCover } from 'components/hooks/pageCover/pageCover';
import SentryWrap from 'components/Sentry';
import { useStandards } from "store/story/selectors";
import { compareGradeLevels, compareGradesForIllinoisCommonCore, normalizeStateForComparison, statesMatch, getStateNameFromCode, getStateNameDisplayForCode } from 'utils/lib/standardHelper';
import { useOrgStandardCodes } from 'store/organizations/selectors';
import MultiSelect from 'components/MultiSelectorSearch';
import { InfoOutlined } from '@mui/icons-material';
import StandardsModal from 'components/StandardsModal';
import { handleAutoSelectStandardsForAllQuestions } from 'store/story/thunks';

//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const LABEL = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j']

const Container = styled.div`
    width: 100%;
`;

const Description = styled.span`
    color: ${COLOR.black300};
    display: block;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    margin-bottom: 25px;
`;

const Header = styled(Description)`
    color: ${COLOR.black100};
    font-size: 28px;
    font-weight: 600;
    line-height: 28px;
    margin-bottom: 16px;
`;

const Wrapper = styled.div`
    margin: 0px auto;
    width: 100%;
    position: relative;
    top: 0px;
`;
const AssignmentDescription = styled.span`
    color: ${COLOR.black300};
    display: block;
    font-size: 12px;
    font-weight: 400;
    line-height: 17px;
`;

const StyledFormControl = muiStyled(FormControl)(({ theme }) => ({
  minWidth: 120,
  width: '100%',
  margin: '10px 0',
}));

const StyledInputLabel = muiStyled(InputLabel)({
  backgroundColor: 'white',
  paddingRight: 5,
});

const Image = styled.img`
    background-color: ${COLOR.white};
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    height: auto;
    width: 100%;
`;

const ImageContiner = styled.div`
    background-color: transparent;
    border: none;
    flex: 1;
    outline: none;
    width: 100%;
    height:100%;
    margin-right: 16px;
    position: relative;
`;

const RelativeContainer = styled.div`
    position: relative;
    width: 100%;
    padding: 10px;
    margin: 2px;
    border: 1px dashed;
    margin-top:16px;
    margin-bottom:16px;
`;
const SortableRow = styled.div`
    align-items: center;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    display: flex;
    gap: 12px;
    margin-bottom: 8px;
    padding: 12px 16px;
    background: #fafafa;
    cursor: grab;
    &:active {
        cursor: grabbing;
    }
`;
const AssignmentTitle = styled.span`
    color: ${COLOR.black100};
    display: block;
    font-size: 16px;
    font-weight: 600;
    line-height: 18px;
`;
const Question = styled(AssignmentTitle)`
    font-size: 16px;
    line-height: 22px;
    margin-top:10px;
`;


const QuestionContainer = styled(Container)`
    margin-top: 0px;
    position: relative;
`;


const useStyles = makeStyles((theme) => ({
    root: {
        marginBottom: '25px',
        width: '300px'
    },
    rootDif: {
        width: '200px'
    },
    rootDifFull: {
        width: "100%"
    },
    sizeSmall: {
        width: '55px',
        height: '25px'
    },
    checkedSwitch: {
        transform: 'translateX(30px) !important'
    },
    label: {
        textTransform: 'uppercase',
    },
    formControl: {
        minWidth: 120
    },
    colorPrimary: {
        color: `${COLOR.green}!important`
    },
    checkroot: {
        display: 'flex',
        flexDirection: 'column'
      },
      checkformControl: {
        minWidth: 300,
      },
      checksectionTitle: {
      },
      formGroup: {
        flexDirection: 'row', // Arrange checkboxes in a row
        gap:12
      },
      checkbox: {
        '&.Mui-checked': {
          color: COLOR.green100, // Custom checked color (green)
        },
      },


}));

const Content = styled.div`
    margin-top: 14px;
`;

const Detail = styled(AssignmentDescription)`
    color: ${COLOR.black600};
    display: inline-block;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    margin-top:${p => p.index == 0 ? "opx" : "24px"}
`;

const InnerWrapper = styled.div`
        height: 100%;
        padding: 0px;
        width: 100%;
        overflow-y:scroll;
        overflow-x: hidden;
        scroll-behavior: smooth;
        height: max-content;
        padding-bottom: 5px;
        max-height:52vh;
        border-bottom: 1px dotted;
        padding-right: 6px;
        ::-webkit-scrollbar {
            width: 5px;
            height: 3px;
          }
}
`;
const RadioColumn = styled(Col)`
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 22px;
`;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

function getStyles(name, studentsName, theme) {
    return {
        fontWeight:
            studentsName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

function ensureQuestionUids(questionsList) {
    if (!Array.isArray(questionsList)) return questionsList;
    return questionsList.map(q => ({
        ...q,
        _uid: q._uid || `q-${Math.random().toString(36).slice(2)}`,
    }));
}
function getQuestionPreviewText(question) {
    if (!question || !question.question) return '';
    const raw = typeof question.question === 'string' ? question.question : '';
    return raw.replace(/<[^>]*>/g, '').trim().slice(0, 60) || 'Question';
}

function SortableQuestionItem({ question, index, sortableId }) {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: sortableId });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };
    return (
        <SortableRow ref={setNodeRef} style={style} {...attributes} {...listeners}>
            <DragIndicatorIcon style={{ color: '#999' }} />
            <span style={{ fontWeight: 600, minWidth: 90 }}>Question {question.id ?? index + 1}</span>
            <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: 13, color: '#666' }}>
                {getQuestionPreviewText(question)}
            </span>
            <span style={{ fontSize: 12, color: '#1976d2', fontWeight: 500, whiteSpace: 'nowrap' }}>
                New order: {index + 1}
            </span>
        </SortableRow>
    );
}

function RearrangeQuestionsList({ reorderList, setReorderList }) {
    const sensors = useSensors(
        useSensor(PointerSensor, { activationConstraint: { distance: 8 } })
    );
    const sortableIds = reorderList.map((q, i) => q._uid ?? q.id ?? `q-${i}`);
    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (!active || !over || active.id === over.id) return;
        const oldIndex = reorderList.findIndex((q, i) => (q._uid ?? q.id ?? `q-${i}`) === active.id);
        const newIndex = reorderList.findIndex((q, i) => (q._uid ?? q.id ?? `q-${i}`) === over.id);
        if (oldIndex === -1 || newIndex === -1) return;
        setReorderList(arrayMove(reorderList, oldIndex, newIndex));
    };
    return (
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
            <SortableContext items={sortableIds} strategy={verticalListSortingStrategy}>
                <div style={{ padding: '8px 0', maxHeight: 400, overflowY: 'auto' }}>
                    <div style={{ marginBottom: 12, fontSize: 13, color: '#666' }}>
                        Drag to reorder. "New order" shows the position (1, 2, 3…) after rearranging.
                    </div>
                    {reorderList.map((question, index) => (
                        <SortableQuestionItem
                            key={question._uid ?? question.id ?? `q-${index}`}
                            question={question}
                            index={index}
                            sortableId={question._uid ?? question.id ?? `q-${index}`}
                        />
                    ))}
                </div>
            </SortableContext>
        </DndContext>
    );
}


const AssignmentForm = ({
    data,
    bookId,
    pageId,
    open,
    onClose,
    currentUser,
    ai_questions,
    assignmentTitle,
    storyInstruction = '',
    article_level_id,
    setAssignmentAiModal = () =>{},
    from = '',
    formResource = '',
    onCloseEntireAiFlow
}) => {
    const {setAlertLoading, showAlert} = useAlertLoading();
    const [buttonDisabled,setButtonDisabled] = useState(false);
    const classActivities = useClassActivities()
    const classQuizzes = useClassQuizzes()
    const userClasses = useUserClasses()
    const bookUnitList = useBookUnits()
    const classes = useStyles();
    const unitBasedBookIds = ['33', '43', '49', '41'];
    const [questions, setQuestions] = useState([])
    const [displayName, setdisplayName] = useState('')
    const [loading, setLoading] = useState(false)
    const [languageFeedback, setLanguageFeedback] = useState('SPANISH')
    const [assignmentStandards, setAssignmentStandards] = useState([])
    const [errors, setError] = useState([])
    const dispatch = useDispatch()
    const isEditing = has(data, "id")
    const standards = useStandards()
    const enabledStateCodes = useOrgStandardCodes();
    const [standardInfoModal, setStandardInfoModal] = useState({ open: false, standardAbbrs: [], stateStandard: null });
    const [rearrangeModalOpen, setRearrangeModalOpen] = useState(false);
    const [reorderList, setReorderList] = useState([]);
    const questionsRef = useRef([])
    const innerRef = useRef(null)
    const booksAllList = useAllBook()
    const resources = useResources()
    const getBookData = find(booksAllList, (book) => book.id === bookId);
    const [isAssigned, setAssigned] = useState(true)
    const [assignedloading,setAssignedLoading] = useState(false)
    const [assignmentAiSectionModal, setAssignmentAiSectionModal] = useState(false)
    const dispNameRef = useRef();
    const questionRefs = useRef([]);
    const optionRefs = useRef([]);
    const answerRefs = useRef([]);
    const landscapeOrientation = useOrientationFullScreen();
    const [create_new_copy,setCreateNewCopy] = useState(false)
    const [assignmentMessage,setAssignmentMessage] = useState('This activity has already been assigned  therefore you cannot make changes. You can make a copy of this assignment and assign it to your other classes.')
    const [ai_grading_config,setAi_grading_config] = useState({})
    const isTablate = useTabletDetection();
    const [inputValue, setInputValue] = useState({});
    const [optionStates, setOptionStates] = useState({});
    const is_soy_story = useMemo(() => (typeof storyInstruction == "string" && storyInstruction.length > 0) || (data && typeof data.storyInstruction == "string" && data.storyInstruction.length > 0), [data])
    const is_article_level = useMemo(() => (typeof article_level_id == "string" && article_level_id.length > 0) || (data && typeof data.article_level_id == "string" && data.article_level_id.length > 0), [data])
    const is_worksheet = useMemo(() => data && data?.data?.type === 'worksheet' || data?.data?.assignmentType === 'worksheet', [data])
    const coverTitle = useAssignmentCoverTitle({ assignment: data, title: displayName || data?.displayName || '' });
    const { updatePopUpAtOnce} = usePopUpAtOnce();
    const renderedGroups = new Set();
    const assignedActivity = classActivities?.find((x) => x?.data?.id === data?.id);
    const assignedData = assignedActivity && Object.keys(assignedActivity).length > 0 
    ? assignedActivity 
    : classQuizzes?.find((x) => x?.data?.id === data?.id);
    const [initData,setInitData] = useState(null);
    const standard_exams = useStandardExams();
    const exams = useExams();
    const isStandardExam = useMemo(() => checkStandardExam(bookId,standard_exams), [bookId,standard_exams])
    const isExam = exams.some(entry =>
        entry.exams.some(config => config.bookId === bookId)
    );
    
    const isExamOrStandardExam = useMemo(() => isExam || isStandardExam, [isExam, isStandardExam]);
    const pageCover = usePageCover({ assignmentData: data });
    const balconPages = useMemo(() => {
        if (from === 'balcon' || unitBasedBookIds.includes(bookId)) {
            return get(find(bookUnitList, ["bookId", bookId]), "pages", []);
        }
        return [];
    }, [bookUnitList, bookId, from]);

    const bookContentData = useMemo(() => {
        if (bookId && booksAllList) {
            const content = getBookContent(bookId, booksAllList);
            return content.length > 0 ? { content } : null;
        }
        return null;
    }, [bookId, booksAllList]);
    const scrollToBottom = () => {
        if (innerRef.current) {
            setTimeout(() => {
                innerRef.current.scrollTo(0,innerRef.current.scrollHeight)
            }, 500)
        }
    }
    const getImages = React.useCallback(() => {
        if(pageCover){
            return pageCover;
        }
        if(is_soy_story){
            return SoyHistoriasNew;
        }
        if(is_article_level){
            return SoyStoryImg;
        }
         if (imageFetchFromPodcast(bookId, resources)) {
            return imageFetchFromPodcast(bookId, resources)
        } else {
            return get(imageFetchDinamic(bookId, pageId, booksAllList), "resource")
        }
    })

    // const displayNameSoyHistoras = useMemo(() => {
    //    const displayname = assignedData ? assignedData?.displayName ? assignedData?.displayName: assignedData?.data?.displayName: initData?.displayName;
    //    return displayname;
    // }, [assignedData,initData])

        useEffect(() => {
             if (data?.id !==  initData?.id) {
               setInitData(data);
             }
           }, [data?.id]);

    const trenacriptAudio = (url) => {
        handleAudioTranscript(url)
    }
    
    const onCloseDrawer = (options = {}) => {
        const { reopenAiModal = true } = options;
        if(buttonDisabled){
            showAlert("Please wait until the process is complete", "error");
            return;
        }
        updatePopUpAtOnce(false)
        onClose();
        if (reopenAiModal) {
            setAssignmentAiModal(true);
        }
        
        setError([])
        setAssignmentStandards([])
    }
    const onChangeEditType = () => {
        if (isEditing || get(data, "cloneId")) {
            if (data.questions && data.questions.length > 0) {
                const updatedQuestionsType = data.questions.map(question => {
                    const updatedQuestion = { ...question };
                    
                    if (question.type === 'email') {
                        updatedQuestion.type = 'essay';
                    }
                    if (question.type === 'twoMinAudio') {
                        updatedQuestion.type = 'audio';
                        updatedQuestion.duration = 120;
                    }
                    if (question.type === 'audioEssay' && !question.groupKey) {
                        updatedQuestion.groupKey = `essay-audio-${Math.random().toString(36).substring(2, 15)}`;
                    }
                    
                    if (question.state_standard && Array.isArray(question.state_standard)) {
                        updatedQuestion.state_standard = question.state_standard.map(stateStd => {
                            if (!stateStd) {
                                return {
                                    standard_name: '',
                                    grade: null,
                                    standard: []
                                };
                            }
                            if (typeof stateStd === 'string') {
                                return {
                                    standard_name: stateStd,
                                    grade: null,
                                    standard: []
                                };
                            }
                            return {
                                standard_name: stateStd?.standard_name || '',
                                grade: stateStd?.grade || null,
                                standard: Array.isArray(stateStd?.standard) ? stateStd.standard : (stateStd?.standard ? [stateStd.standard] : [])
                            };
                        }).filter(Boolean);
                    }
                    
                    return updatedQuestion;
                });
                return updatedQuestionsType;
            }
        }
        return [];
    };

    const hasTextContent = (htmlContent) => {
        if (!htmlContent) {
            return false;
        }
        
        if (typeof htmlContent !== 'string') {
            return false;
        }
        
        const trimmedContent = htmlContent.trim();
        if (trimmedContent.length === 0) {
            return false;
        }
        
        const emptyHtmlPatterns = [
            /^<p><br\s*\/?><\/p>$/i,
            /^<p><\/p>$/i,
            /^<p>\s*<\/p>$/i,
            /^<p>\s*<br\s*\/?>\s*<\/p>$/i,
            /^<div><br\s*\/?><\/div>$/i,
            /^<div><\/div>$/i,
            /^<div>\s*<\/div>$/i,
            /^<br\s*\/?>$/i,
            /^&nbsp;$/i,
            /^<p>&nbsp;<\/p>$/i,
            /^<p>\s*&nbsp;\s*<\/p>$/i,
            /^<p>\s*&nbsp;\s*<br\s*\/?>\s*<\/p>$/i,
            /^<p><br\s*\/?>\s*&nbsp;\s*<\/p>$/i
        ];
        
        const matchesEmptyPattern = emptyHtmlPatterns.some(pattern => pattern.test(trimmedContent));
        if (matchesEmptyPattern) {
            return false;
        }
        
        try {
            const tempElement = document.createElement('div');
            tempElement.innerHTML = htmlContent;
            const textContent = tempElement.textContent || tempElement.innerText || '';
            const cleanedText = textContent.replace(/\u00A0/g, ' ').replace(/\s+/g, ' ').trim();
            
            
            return cleanedText.length > 0;
        } catch (error) {
            return false;
        }
    };

    useEffect(() => {
        questionsRef.current = questions;
    }, [questions]);



    const filteredStandardsOptions = useMemo(() => {
        const ebookGradeLevels = getBookData?.grade_levels || [];
        const ebookGradeLevel = getBookData?.grade_level;
        
        let filteredByState = standards;
        if (enabledStateCodes && enabledStateCodes.length > 0) {
            filteredByState = filter(standards, (standard) => {
                const standardStatus = get(standard, 'status', false);
                if (standardStatus !== true) return false;
                const standardState = get(standard, 'state', '');
                const standardStateName = normalizeStateForComparison(standardState);
                const enabledStateNames = enabledStateCodes.map(code => normalizeStateForComparison(code)).filter(Boolean);
                return enabledStateNames.some(enabledName => statesMatch(standardState, enabledName));
            });
        } else {
            filteredByState = filter(standards, (standard) => {
                const standardStatus = get(standard, 'status', false);
                return standardStatus === true;
            });
        }
        
        if (Array.isArray(ebookGradeLevels) && ebookGradeLevels.length > 0) {
            const ebookStates = [...new Set(ebookGradeLevels.map(item => get(item, 'state', '')).filter(Boolean))];
            const ebookGrades = [...new Set(ebookGradeLevels.map(item => get(item, 'grade_level', '')).filter(Boolean))];
            
            return map(
                filter(filteredByState, (standard) => {
                    const standardStatus = get(standard, 'status', false);
                    if (standardStatus !== true) return false;
                    const standardState = get(standard, 'state', '');
                    const standardGradeLevel = get(standard, 'grade_level', '');
                    
                    const stateMatches = ebookStates.some(ebookState => statesMatch(standardState, ebookState));
                    
                    if (!stateMatches) return false;
                    
                    if (!standardGradeLevel || ebookGrades.length === 0) return true;
                    
                    const standardGrades = String(standardGradeLevel).split(',').map(g => g.trim()).filter(g => g);
                    
                    return ebookGrades.some(ebookGrade => 
                        standardGrades.some(standardGrade => compareGradesForIllinoisCommonCore(ebookGrade, standardGrade, standardState))
                    );
                }),
                k => k.abbr
            );
        } else if (ebookGradeLevel) {
            const ebookGrades = ebookGradeLevel.split(',').map(g => g.trim()).filter(g => g);
            
            return map(
                filter(filteredByState, (standard) => {
                    const standardStatus = get(standard, 'status', false);
                    if (standardStatus !== true) return false;
                    const standardGradeLevel = get(standard, 'grade_level', '');
                    if (!standardGradeLevel) return true;
                    
                    const standardGrades = standardGradeLevel.split(',').map(g => g.trim()).filter(g => g);
                    const standardState = String(get(standard, 'state', '')).toUpperCase();
                    
                    return ebookGrades.some(ebookGrade => 
                        standardGrades.some(standardGrade => compareGradesForIllinoisCommonCore(ebookGrade, standardGrade, standardState))
                    );
                }),
                k => k.abbr
            );
        }
        
        return map(filter(filteredByState, (standard) => {
            const standardStatus = get(standard, 'status', false);
            return standardStatus === true;
        }), k => k.abbr);
    }, [standards, getBookData?.grade_levels, getBookData?.grade_level, enabledStateCodes]);
    
    const assignmentStandardsOptions = useMemo(() => {
        return filteredStandardsOptions.map(abbr => ({
            label: abbr,
            value: abbr
        }));
    }, [filteredStandardsOptions]);
    
    const onSubmit = async (e) => {
        try{
            e.preventDefault();
            await new Promise(resolve => setTimeout(resolve, 100));
            const error = [] 
        const assignmentData = {
            ...data,
            chapter: bookId,
            bookId: bookId,
            displayName: displayName,
            page: pageId || bookId,
            questions: (questionsRef.current || []).map(({ _uid, ...q }) => q),
            typeId: (isEditing && data.typeId) ? data.typeId : 'activity',
            createdBy: get(currentUser, "id"),
            language_feedback: languageFeedback,
            create_new_copy:create_new_copy,
            is_ai: ai_questions?.length > 0 ? true : false,
            ai_grading_config,
            storyInstruction,
            article_level_id,
            resource: formResource === 'resource',
            standards: assignmentStandards && assignmentStandards.length > 0 ? assignmentStandards : undefined
        }
        if(create_new_copy){
            assignmentData.createdBy = currentUser.id 
        }
        setLoading(true)
        if (!assignmentData.displayName) {
            error.push({ type: 'display_name', message: 'Displayname required' })
        }
        if (!assignmentData.language_feedback) {
            error.push({ type: 'language_feedback', message: 'Language feedback required!' })
        }
        if (!Array.isArray(assignmentData.questions) || assignmentData.questions.length == 0) {
            error.push({ type: 'question_error', message: 'Questions are required , please add atleast one question.' })
        } else {
            const questionErrorNumbers = new Set();
            const instructionErrorNumbers = new Set();
            const optionErrorNumbers = new Set();
            const audioErrorNumbers = new Set();
            let hasQuestionError = false
            let hasInstructionError = false
            let hasOptionErrorError = false
            let hasAudioError = false
            assignmentData.questions.map((q, i) => {
                const hasQuestionContent = hasTextContent(q.question);
                if (!hasQuestionContent && q.type !== "picture" && q.type !== "fillingImage" && q.type !== "audio") {
                    if (q.type === 'audioToImage') {
                        instructionErrorNumbers.add(i + 1);
                        hasInstructionError = true;
                    } else if (q.type !== 'match' && q.type !== 'filling') {
                        questionErrorNumbers.add(i + 1);
                        hasQuestionError = true;
                    }
                }
                if (q.type === 'multipleChoice' || q.type === 'trueFalse' || q.type === 'audioTrueFalse' || q.type === 'audioMultipleChoice' || q.type === 'multipleResponse') {
                    const noOption = filter(q.options, (o, i) => !o)
                    if (noOption.length > 0) {
                        hasOptionErrorError = 2;
                        optionErrorNumbers.add(i + 1);
                    }
                }

                if(q.type === "audio"){
                    const hasAudioQuestionContent = hasTextContent(q.question);
                    if (!hasAudioQuestionContent && !q.audio) {
                        error.push({type:"display_name", questionIndex: i, message: `Question ${i + 1}: Either question text or audio file is required`});
                    }
                }

                if(q.type === "video"){
                    const hasVideoQuestionContent = hasTextContent(q.question);
                    if (!hasVideoQuestionContent) {
                        questionErrorNumbers.add(i + 1);
                        hasQuestionError = true
                    }
                }

                if(q.type === "photoCollage"){
                    const hasPhotoCollageQuestionContent = hasTextContent(q.question);
                    if (!hasPhotoCollageQuestionContent) {
                        questionErrorNumbers.add(i + 1);
                        hasQuestionError = true
                    }
                    if(q?.categoryType?.includes("Text") || q?.categoryType?.includes("Audio")){
                        if(q?.type_question_desc?.length === 0 || !q?.type_question_desc){
                            error.push({type:"display_name", questionIndex: i, message: `Question ${i + 1}: Collage Description is required`});
                        }
                    }
                }

                if (q.type === "picture") {
                    const hasPictureQuestionContent = hasTextContent(q.question);
                    if ((!q.pictures || q.pictures.length === 0 || q.pictures === "") && !hasPictureQuestionContent) {
                        error.push({ type: 'display_name', questionIndex: i, message: `Question:${i + 1} Atleast one of thing is required either question or picture` });
                    }
                }

                if (q?.type === "match") {
                    const matchErrors = validateMatchMaking(q, i);
                    error.push(...matchErrors);
                }
                if (q.type === "filling" || q.type === "fillingImage") {
                    //highlightWords at least two options are required
                    if (q.answerSelected && q.answerSelected?.length !== 0) {
                        q.answerSelected.forEach((x, qindex) => {
                            if (!x || x?.length < 2) {
                                if(q.response_type === "dropdown"){
                                    error.push({ type: 'filling_error', questionIndex: i, message: `Fill in the blanks:${i + 1}.${qindex + 1} Atleast two options are required.` });
                                }
                            }
                        })
                    }
                    // if (q.highlightWords && q.highlightWords?.length !== 0) {
                    //     q.highlightWords.forEach((x, qindex) => {
                    //         if (!x || x?.length < 1) {
                    //             error.push({ type: 'filling_error_highlight', message: `Fill in the blanks:${i + 1}.${qindex + 1} Answer must be selected from sentence.` });
                    //         }
                    //     })
                    // }

                    if (q.type === "fillingImage" || q.fillingType === 'Audio' || q.fillingType === 'Image') {
                        q.filling_image.forEach((element, index) => {
                            if (index === 0 && (!element?.url || element?.url?.length === 0)) {
                                error.push({ type: 'display_name', message: `Instruction: ${i + 1}.${index + 1} ${q.fillingType} is required.` });
                            }
                        })
                    }
                    const hasQuestionContent = hasTextContent(q.question);
                    if (!hasQuestionContent) {
                        error.push({ type: 'display_name', questionIndex: i, message: `Instruction: ${i + 1} Instruction is required.` });
                    }

                    if (q.options && q.options.length > 0) {
                        q.options.forEach((option, qindex) => {

                            if (!option || option?.trim().length === 0) {
                                error.push({
                                    type: 'display_name',
                                    questionIndex: i,
                                    message: `Question:${i + 1}.${qindex + 1}.  is required.`
                                });
                            }
                        });
                    }

                    if (q.answerSelected && q.answerSelected?.length !== 0) {
                        q.answerSelected.forEach((x, index) => {
                            if (!x || x?.length === 0 || x.every(ans => !ans?.text || ans?.text?.length === 0)) {
                                error.push({ type: 'display_name', message: `Answer:${i + 1}.${index + 1} Atleast one answer is required.` });
                            }
                        })
                    }

                    if (q.highlightWords && q.highlightWords?.length > 0) {
                        q.highlightWords.forEach((x, qindex) => {
                            let hasHighlightError = false;
                            if (!x || x?.length === 0) {
                                error.push({ type: 'display_name', message: `Highlight-word:${i + 1}.${qindex + 1} Atleast one option must be selected.` });
                                hasHighlightError = true;
                            }
                            if (!hasHighlightError && x) {
                                const hasEmptyText = x.some(hw => hw?.text === "" || hw?.text?.length === 0);
                                if (hasEmptyText) {
                                    error.push({ type: 'display_name', message: `Highlight-word:${i + 1}.${qindex + 1} Atleast one option must be selected.` });
                                }
                            }
                        })
                    }
                }
                if (q.type === 'audioToImage' || q.type === 'audioTrueFalse' || q.type === 'audioEssay') {
                    if (!q.audio) {
                        audioErrorNumbers.add(i + 1);
                        hasAudioError = true
                    }
                }
                if (q.type === 'audioMultipleChoice' && q.groupKey) {
                    const isFirstInGroup = assignmentData.questions.findIndex(
                        quest => quest.type === 'audioMultipleChoice' && quest.groupKey === q.groupKey
                    ) === i;
                    if (isFirstInGroup && !q.audio) {
                        audioErrorNumbers.add(i + 1);
                        hasAudioError = true
                    }
                }
            })
            const messageQ = hasQuestionError ? `Question text required on q.no (${Array.from(questionErrorNumbers).sort((a, b) => a - b).join(', ')})` : '';
            const messageInstruction = hasInstructionError ? `Instruction text required on q.no (${Array.from(instructionErrorNumbers).sort((a, b) => a - b).join(', ')})` : '';
            const audioMessage = hasAudioError ? `Audio file required on (${Array.from(audioErrorNumbers).sort((a, b) => a - b).join(', ')})` : '';
            const optionMessage = hasOptionErrorError ? `Option text required on (${Array.from(optionErrorNumbers).sort((a, b) => a - b).join(', ')})` : '';
            let finalMessage = ``
            if (hasQuestionError) {
                finalMessage += messageQ + ".\n"
            }
            if (hasInstructionError) {
                finalMessage += messageInstruction + ".\n"
            }
            if (hasAudioError) {
                finalMessage += audioMessage + ".\n"
            }
            if (hasOptionErrorError) {
                finalMessage += optionMessage + ".\n"
            }
            if (finalMessage) {
                const allIndices = [...questionErrorNumbers, ...optionErrorNumbers, ...audioErrorNumbers].map(n => n - 1);
                error.push({
                    type: "question_error",
                    questionIndices: [...new Set(allIndices)],
                    message: finalMessage
                })
            }
        }
        setError(error)
        if (error.length == 0) {
            const ebookGradeLevels = getBookData?.grade_levels || [];
            const hasEbookStandards = Array.isArray(ebookGradeLevels) && ebookGradeLevels.length > 0;
            
            const questionsWithStandards = assignmentData.questions.filter(q => {
                if (!q.state_standard || !Array.isArray(q.state_standard) || q.state_standard.length === 0) {
                    return false;
                }
                return q.state_standard.some(stateStd => {
                    const standardArray = Array.isArray(stateStd?.standard) ? stateStd.standard : (stateStd?.standard ? [stateStd.standard] : []);
                    return standardArray.length > 0;
                });
            });
            
            const questionsWithoutStandards = assignmentData.questions.filter(q => {
                if (!q.state_standard || !Array.isArray(q.state_standard) || q.state_standard.length === 0) {
                    return true;
                }
                return !q.state_standard.some(stateStd => {
                    const standardArray = Array.isArray(stateStd?.standard) ? stateStd.standard : (stateStd?.standard ? [stateStd.standard] : []);
                    return standardArray.length > 0;
                });
            });
            
            // Call API when:
            // 1. Creating a new assignment (!isEditing): Always call if ebook has standards and there are questions without standards
            //    (even if ebook already has standards run, new questions still need standards assigned)
            // 2. Editing an assignment (isEditing): Only call if some questions have standards and some don't
            //    (mixed state - means new questions were added that need standards)
            const shouldCallAutoSelectAPI = hasEbookStandards && 
                questionsWithoutStandards.length > 0 && 
                (!isEditing || (isEditing && questionsWithStandards.length > 0));

                if (shouldCallAutoSelectAPI) {
                try {
                    setAlertLoading(true, 'Auto-selecting standards for questions...');
                    
                    const questionsWithoutStandardsIndices = assignmentData.questions
                        .map((q, index) => {
                            const hasStandards = q.state_standard && Array.isArray(q.state_standard) && q.state_standard.length > 0 && 
                                q.state_standard.some(stateStd => {
                                    const standardArray = Array.isArray(stateStd?.standard) ? stateStd.standard : (stateStd?.standard ? [stateStd.standard] : []);
                                    return standardArray.length > 0;
                                });
                            return hasStandards ? null : index;
                        })
                        .filter(index => index !== null);
                    
                    const questionsPayload = questionsWithoutStandardsIndices.map((originalIndex) => {
                        const q = assignmentData.questions[originalIndex];
                        return {
                            type: q.type,
                            id: q.id || originalIndex + 1,
                            expected_answer: q.expected_answer || [],
                            question: q.question || ""
                        };
                    });
                    
                    // Filter gradeLevels based on district's enabled state standards
                    const enabledStateNames = enabledStateCodes.map(code => normalizeStateForComparison(code)).filter(Boolean);
                    const commonCoreStateName = normalizeStateForComparison('COMMONCORE');
                    
                    const filteredGradeLevels = ebookGradeLevels.filter((gradeLevelItem) => {
                        const stateCode = get(gradeLevelItem, 'state', '');
                        if (!stateCode) return false;
                        
                        const stateNameNormalized = normalizeStateForComparison(stateCode);
                        
                        // Always include Common Core
                        if (stateNameNormalized === commonCoreStateName) {
                            return true;
                        }
                        
                        // Include if state matches any enabled state
                        if (enabledStateNames.length === 0) {
                            return false; // If no enabled states, only include Common Core
                        }
                        
                        return enabledStateNames.some(enabledName => statesMatch(stateCode, enabledName));
                    });
                    
                    const result = await dispatch(handleAutoSelectStandardsForAllQuestions({
                        questions: questionsPayload,
                        bookId: String(bookId),
                        pageId: pageId ? parseInt(pageId) : null,
                        gradeLevels: filteredGradeLevels
                    }));
                    
                    if (result && Array.isArray(result) && result.length > 0) {
                        const updatedQuestions = cloneDeep(assignmentData.questions);
                        
                        result.forEach((item, resultIndex) => {
                            const originalQuestionIndex = questionsWithoutStandardsIndices[item.questionIndex !== undefined ? item.questionIndex : resultIndex];
                            if (originalQuestionIndex !== undefined && updatedQuestions[originalQuestionIndex]) {
                                if (item.state_standard && Array.isArray(item.state_standard)) {
                                    updatedQuestions[originalQuestionIndex].state_standard = item.state_standard;
                                } else if (item.standards && Array.isArray(item.standards) && item.standards.length > 0) {
                                    const validStandards = item.standards.filter((abbr) => {
                                        return find(standards, (st) => st.abbr === abbr) !== undefined;
                                    });
                                    
                                    if (validStandards.length > 0 && item.state && item.grade !== undefined) {
                                        updatedQuestions[originalQuestionIndex].state_standard = [{
                                            grade: item.grade,
                                            standard: validStandards,
                                            standard_name: item.state
                                        }];
                                    }
                                }
                            }
                        });
                        
                        assignmentData.questions = updatedQuestions;
                        questionsRef.current = updatedQuestions;
                        setQuestions(updatedQuestions);
                        showAlert('Standards generated for this activity', 'success');
                    }
                    
                    setAlertLoading(false, '');
                } catch (apiError) {
                    setAlertLoading(false, '');
                    console.error('Error auto-selecting standards:', apiError);
                }
            }
            
            if (isEditing) {
                await dispatch(handleUpdateCustomAssignment(assignmentData,false,create_new_copy))
            } else {
                await dispatch(handleCreateCustomAssignment(assignmentData))
            }
            const shouldCloseEntireAiFlow = typeof onCloseEntireAiFlow === 'function'
            onCloseDrawer({ reopenAiModal: !shouldCloseEntireAiFlow })
            if (shouldCloseEntireAiFlow) {
                onCloseEntireAiFlow()
            } else {
                onClose()
            }
        }

        }catch(error){
            Sentry.captureException(`569 Error in onSubmit: ${error}`);
            console.log(error);
        }
        finally{
            setLoading(false)
        }
        
    };
    const fetchStatus = async()=>{
        setAssignedLoading(true)
        const ID = get(data, "id")?get(data, "id"):get(data, "cloneId")
        const status = await handleGetAssignmentStatus(ID,currentUser.id)
        const statusList = Array.isArray(status) ? status : []
        const userClassForAssignment = (classId) =>
            find(userClasses, (u) => u.id === classId || String(u.id) === String(classId))
        const activeAssignedStatus = filter(statusList, (k) => {
            const uc = userClassForAssignment(k.classId)
            return Boolean(uc && !uc.archived)
        })
        const classesAssiged = map(activeAssignedStatus, (k) =>
            get(userClassForAssignment(k.classId), "displayName")
        ).filter(Boolean)
        if(activeAssignedStatus.length>0){
            setAssigned(true)
            if(get(data, "cloneId")){
                const aText = `This activity has already been assigned (${classesAssiged.join(",")}) therefore you cannot make changes. You can make a copy of this assignment and assign it to your other classes.`;
                setAssignmentMessage(aText)
            }else{
                const aText = `This activity has already been assigned (${classesAssiged.join(",")}) therefore you cannot make changes. You can make a copy of this assignment and assign it to your other classes.`;
                setAssignmentMessage(aText)
            }
        }else{
            setAssigned(false)
            setAssignmentMessage('')
        }
        setAssignedLoading(false)
    }
    useEffect(() => {
        if(open&&(get(data, "id")||get(data, "cloneId"))){
            fetchStatus()
        }else{
            setAssigned(false)
            setAssignmentMessage('')
        }
        setCreateNewCopy(false)
    }, [classActivities, classQuizzes, open, data])
    useEffect(() => {
        if (data) {
            const onChangeUpdateType = onChangeEditType();
          if (questions.length === 0 || data.id !== initData?.id) {
            setQuestions(ensureQuestionUids(onChangeUpdateType || []))
          }
            setdisplayName(data?.displayName || '');
            setLanguageFeedback(get(data, "language_feedback", 'SPANISH') || 'SPANISH')
            setAi_grading_config(get(data, "ai_grading_config", {}))
            const existingStandards = get(data, "standards", []) || get(data, "standard", []);
            setAssignmentStandards(Array.isArray(existingStandards) ? existingStandards : (existingStandards ? [existingStandards] : []))
        } else {
            setQuestions([])
            setdisplayName('')
            setLanguageFeedback('SPANISH')
            setAi_grading_config({})
            setAssignmentStandards([])
        }
    }, [data])
    useEffect(() => {
        if (Array.isArray(ai_questions) && ai_questions.length > 0) {
            setQuestions(ensureQuestionUids(ai_questions))
            setdisplayName(assignmentTitle)
            setLanguageFeedback('SPANISH')
        }
    }, [ai_questions,assignmentTitle, open])
    useEffect(() => {
        if (!open) {
            setQuestions([])
            setdisplayName('')
            setLanguageFeedback('SPANISH')
            setAssignmentStandards([])
        }
    }, [open])
    const onAddOption = (index) => {
      try {
        const updatedQuestions = cloneDeep(questions);

        if (!updatedQuestions[index].options) {
          updatedQuestions[index].options = [""]; // Initialize options if not present
        }
        if (!updatedQuestions[index].answerSelected) {
          updatedQuestions[index].answerSelected = [""]; // Initialize options if not present
        }
        if (!updatedQuestions[index].filling_image) {
          updatedQuestions[index].filling_image = [{ url: "" }]; // Initialize options if not present
        }
        if (!updatedQuestions[index].highlightWords) {
          updatedQuestions[index].highlightWords = [
            {
              start: "",
              end: "",
              text: "",
            },
          ]; // Initialize options if not present
        }

        updatedQuestions[index].options.push(""); // Add an empty option
        updatedQuestions[index].answerSelected.push(""); // Add an empty option
        updatedQuestions[index].highlightWords.push([
          {
            start: "",
            end: "",
            text: "",
          },
        ]);

        if (updatedQuestions[index].fillingType === "Image" || updatedQuestions[index].fillingType === "Audio") {
            updatedQuestions[index].filling_image.push([
                {
                    url: "",
                }
            ]);
        }
        setQuestions(updatedQuestions);
      } catch (error) {
        Sentry.captureException(`570 Error in onAddOption: ${error}`);
        console.log(error);
      }
    };

    const onAddMatchOption = (index) => {
        setQuestions((prevQuestions) => {
            const updatedQuestions = cloneDeep(prevQuestions);
            if (!updatedQuestions[index].options) {
                updatedQuestions[index].options = [];
            }
            updatedQuestions[index].options.push({ item: '', match_item: '', match_audio: '', match_text:'' , questionImage:'', questionAudio:''});
            return updatedQuestions;
        });
    };

    const onDeleteMatchOption = (index, optId) => {
        const updatedQuestions = [...questions];
        const currentOptions = get(updatedQuestions, `[${index}].options`, []);
        // Remove the selected option and its corresponding answer
        updatedQuestions[index].options = currentOptions.filter((_, i) => i !== optId);

        // Update the state
        setQuestions(updatedQuestions);
    };

    const resolveQuestionIndex = (prevQuestions, indexOrQuestion) => {
        if (typeof indexOrQuestion === 'number') return indexOrQuestion;
        const uid = indexOrQuestion?._uid ?? indexOrQuestion;
        return prevQuestions.findIndex(q => q._uid === uid);
    };
    const onChangeQuestionData = (val, key, indexOrQuestion) => {
        setQuestions(prevQuestions => {
            const i = resolveQuestionIndex(prevQuestions, indexOrQuestion);
            if (i === -1) return prevQuestions;
            const updatedQuestions = cloneDeep(prevQuestions);
            updatedQuestions[i][key] = val;
            
            if (key === "matchType") {
                updatedQuestions[i].options = [{ item: "", match_item: "", match_audio: "" , match_text:'', questionImage:'', questionAudio:'' }];
            }
            if (key === "questionType") {
                updatedQuestions[i].options = [{ item: "", match_item: "", match_audio: "" , match_text:'', questionImage:'', questionAudio:'' }];
            }
            if (key === "questionType") {
                updatedQuestions[i].options = [{ item: "", match_item: "", match_audio: "" , match_text:'', questionImage:'', questionAudio:'' }];
            }
            if(key === "collageLength"){
                updatedQuestions[i][key] = val;
                const validPhotoCollageData = photoCollageData.filter(item => item && item.id);
                // Slice only the valid items up to the requested length
                const filteredFrames = validPhotoCollageData.slice(0, val);
                updatedQuestions[i]["collageFrame"] = filteredFrames;
            }
            if (key === "fillingType") {
                updatedQuestions[i].filling_image = [{ url: "" }];
            }
            questionsRef.current = updatedQuestions;
            return updatedQuestions;
        });
        setError([]); // Clear error if needed
    };
    const onchangeOptionMatch = (index, optIndex, value, type) => {

        setQuestions(prevQuestions => {
            const newQuestions = cloneDeep(prevQuestions);
            
            if (!newQuestions[index].options) {
                newQuestions[index].options = Array(4).fill('').map(() => ({}));
            }
    
            if (!newQuestions[index].options[optIndex]) {
                newQuestions[index].options[optIndex] = { item: "", match_item: "", match_audio: "" , match_text:'', questionImage:'', questionAudio:''};
            }
    
            newQuestions[index].options[optIndex][type] = value;
            
            return newQuestions;
        });
    };
   
const onChangeQuestionType = (type, indexOrQuestion) => {
    setQuestions(prevQuestions => {
      const i = resolveQuestionIndex(prevQuestions, indexOrQuestion);
      if (i === -1) return prevQuestions;
      let v = cloneDeep(prevQuestions);
      const oldType = v[i].type;
      const oldGroupKey = v[i].groupKey;
      v[i].type = type;
      if(type!=="audioMultipleChoice" && type!=="audioEssay"){
        if (oldGroupKey && (oldType === 'audioMultipleChoice' || oldType === 'audioEssay')) {
          v = v.filter((q, idx) => idx === i || q.groupKey !== oldGroupKey);
        }
        delete v[i].groupKey;
        delete v[i].audio;
      }
      switch (type) {
        case 'multipleChoice':
          v[i].options = Array.isArray(v[i].options) && v[i].options.length === 4
            ? v[i].options
            : ['', '', '', ''];
          v[i].answer = !isNaN(parseInt(v[i].answer)) ? v[i].answer : 0;
          break;

        case 'multipleResponse':
          v[i].options = Array.isArray(v[i].options) && v[i].options.length === 4
            ? v[i].options
            : ['', '', '', ''];
          v[i].answer = Array.isArray(v[i].answer) ? v[i].answer : [];
          break;

        case 'trueFalse':
          v[i].options = ['Cierto', 'Falso'];
          v[i].answer = !isNaN(parseInt(v[i].answer)) ? v[i].answer : 0;
          break;

        case 'audio':
          v[i].duration = 60;
          delete v[i].options;
          delete v[i].answer;
          break;
        case 'audioEssay':
          v[i].duration = 60;
          v[i].audio = '';
          v[i].groupKey = `multichoice-audio-${Math.random().toString(36).substring(2, 15)}`;
          delete v[i].options;
          delete v[i].answer;
          break;
        case 'audioToImage':
          v[i].duration = 60;
          v[i].categoryType = "Image";
          v[i].studentCanUploadImages = v[i].studentCanUploadImages || 6;
          delete v[i].options;
          delete v[i].answer;
          break;
        case 'audioTrueFalse':
          v[i].duration = 60;
          v[i].options = ['Cierto', 'Falso'];
          v[i].answer = !isNaN(parseInt(v[i].answer)) ? v[i].answer : 0;
          break;
        case 'audioMultipleChoice':
          v[i].duration = 60;
          v[i].options = ['', '', '', ''];
          v[i].audio = '';
          v[i].answer = !isNaN(parseInt(v[i].answer)) ? v[i].answer : 0;
          v[i].groupKey = `multichoice-audio-${Math.random().toString(36).substring(2, 15)}`;
          break;
        case 'picture':
          v[i].categoryType = "Image";
          v[i].studentCanUploadImages = v[i].studentCanUploadImages || 6;
          v[i].additionalPictures = v[i].additionalPictures || [];
          delete v[i].options;
          delete v[i].answer;
          break;

        case 'video':
          v[i].duration = 60;
          delete v[i].options;
          delete v[i].answer;
          break;

        case 'match':
          v[i].matchType = "Text";
          v[i].questionType = "Text";
          v[i].options = [{ item: "", match_item: "", match_audio: ""  , match_text: "", questionImage:"", questionAudio:"" }];
          delete v[i].answer;
          break;

        case 'filling':
        case 'fillingImage':
          v[i].options = [""];
          v[i].fillingType = "None";
          v[i].response_type = "dropdown";
          v[i].answer = "";
          v[i].answerSelected = [""];
          v[i].highlightWords = [[{
            start: "",
            end: "",
            text: ""
          }]];
          v[i].selected_answer = [''];
          if (!v[i].question) {
            v[i].question = "";
          }
          
        //   if (type === "fillingImage") {
            v[i].filling_image = [{
              url: ""
            }];
        //   }
          break;
          case "photoCollage":
                // v[i].question = "";
                v[i].collageLength = 6;
                v[i].collageFrame = photoCollageData.slice(0, 6);
                v[i].categoryType =  [];
                break;

        default:
          break;
      }

      return v;
    });
  };
    
    const onchangeOption = (index, optIndex, value, type) => {
        const v = cloneDeep(questions)
        if (v[index].options) {
            v[index].options[optIndex] = value
        } else if (type === 'trueFalse' || type === 'audioTrueFalse') {
            v[index].options = ['Cierto', 'Falso']
            v[index].options[optIndex] = value
        } else {
            v[index].options = ['', '', '', '']
            v[index].options[optIndex] = value
        }
        setQuestions(v)
    }
    const onChangeOptionsLength = (index, length) => {
        const v = cloneDeep(questions)
        if (v[index].options) {
            let opt = v[index].options.slice(0, length)
            if (opt.length == length) {
                v[index].options = opt;
                if (v[index].type === 'multipleResponse') {
                    if (Array.isArray(v[index].answer)) {
                        v[index].answer = v[index].answer.filter(ans => parseInt(ans) < length);
                    }
                } else if (v[index].answer >= opt.length) {
                    v[index].answer = 0;
                }
            } else {
                let len = length - opt.length;
                let arr = new Array(len).fill('', 0, len)
                opt.push(...arr)
                v[index].options = opt;
            }
        } else {
            v[index].options = new Array(length).fill('')
            if (v[index].type === 'multipleResponse') {
                v[index].answer = [];
            } else {
                v[index].answer = 0;
            }
        }
        setQuestions(v)
    }
    const onDeleteQuestion = (indexOrQuestion) => {
        const i = typeof indexOrQuestion === 'number' ? indexOrQuestion : questions.findIndex(q => {
            if(q._uid){
                return q._uid === (indexOrQuestion?._uid ?? indexOrQuestion);
            }
            return q.id === indexOrQuestion?.id || q.id === indexOrQuestion;
        });
        if (i === -1) return;
        const v = cloneDeep(questions)
        removeQuestionError(i, questions, setError)
        v.splice(i, 1)
        setQuestions(v)
    }
    const onAddQuestionWithAI = () => {
        setAssignmentAiSectionModal(true);
    };
    const onAddQuestion = () => {
        const v = cloneDeep(questions)
        let _id = parseInt(get(v[v.length - 1], "id", 0))
        _id = isNaN(_id) ? 0 : _id + 1
        v.push({
            "type": "essay",
            "id": _id,
            _uid: `q-${Math.random().toString(36).slice(2)}`,
        })
        setQuestions(v)
        scrollToBottom()
    }
   const onSetCopyTrue = () => {
     setCreateNewCopy(true)
     setdisplayName(`${displayName} (copy)`)
   }

   useEffect(() => {
    if(open){
        document.body.classList.add("overflow-hidden");
    }
    return ()=>{
        document.body.classList.remove("overflow-hidden");
    }
   }, [open])

   useEffect(() => {
    if (open) {
       disableBodyScroll('AssignmentForm');
    } else {
        document.body.style.overflow = "auto";
    }
    return () => {
        document.body.style.overflow = "auto";
    };
}, [open]);
const onChangeAiConfig = (configData) => {
    setAi_grading_config({...ai_grading_config,...configData})
}

    // function for fill in the blanks
    const handleInputChange = (index, optId, value) => {
        setInputValue((prev) => ({
            ...prev,
            [`${index}-${optId}`]: value, // Dynamically set the value for index and optId
        }));
    };

    const getInputValue = (index, optId) => {
        return inputValue[`${index}-${optId}`] || ""; // Get the value or default to an empty string
    };

const checkHighLightWithTyping = (updatedQuestions, index, optId, value) => {
  try {
    if (value?.trim()?.length > 0) {
      const highlightWords = updatedQuestions[index].highlightWords[optId];
      const optionText = value;

      const filterHighlightedWord = highlightWords?.filter((data) => {
        if (optionText?.includes(data?.text)) {
          return true;
        }
        return false;
      }) || [];
      updatedQuestions[index].highlightWords[optId] = filterHighlightedWord;

      if (updatedQuestions[index].answerSelected[optId]?.length > 0) {
        const customAnswerSelected =
          updatedQuestions[index].answerSelected[optId];
        const filterCustomAnswer =
          customAnswerSelected?.filter((data) => data.type === "custom") || [];

        const finalAnswerResult = [
          ...new Set([...filterCustomAnswer, ...filterHighlightedWord]),
        ];
        updatedQuestions[index].answerSelected[optId] = finalAnswerResult;
      }
    }
    return updatedQuestions;
  } catch (error) {
    Sentry.captureException(`571 Error in checkHighLightWithTyping: ${error}`);
    console.log(error);
  }
};

    const onchangeOptionFilling = async (index, optId, value) => {
      try {
        const updatedQuestions = [...(questionsRef.current.length > 0 ? questionsRef.current : questions)];

        // Ensure the question object exists at the given index
        if (!updatedQuestions[index]) {
          updatedQuestions[index] = {
            options: [],
            answerSelected: [],
            highlightWords: [],
          };
        }

        // Ensure the options array exists
        if (!updatedQuestions[index].options) {
          updatedQuestions[index].options = [];
        }

        // Ensure the answer array exists
        if (!updatedQuestions[index].answerSelected) {
          updatedQuestions[index].answerSelected = [];
        }

        // Set the option value
        if (
          updatedQuestions[index].answerSelected &&
          value?.trim()?.length === 0
        ) {
          updatedQuestions[index].answerSelected[optId] = [];
          if (updatedQuestions[index].highlightWords) {
            updatedQuestions[index].highlightWords[optId] = [];
          }
        }
        const filterUpdatedQuestion =  checkHighLightWithTyping(updatedQuestions,index,optId,value);
        filterUpdatedQuestion[index].options[optId] = value || "";
        
        const currentQuestion = questionsRef.current[index] || questions[index];
        if (currentQuestion && currentQuestion.question !== undefined) {
          filterUpdatedQuestion[index].question = currentQuestion.question;
        }
        
        questionsRef.current = filterUpdatedQuestion;
        setQuestions(filterUpdatedQuestion);
    } catch (error) {
        Sentry.captureException(`572 Error in onchangeOptionFilling: ${error}`);
        console.log(error);
      }
    };

    const handlePictureFilling = (index, optId, value) => {
        const updatedQuestions = [...questions];
        if (!updatedQuestions[index].filling_image) {
            updatedQuestions[index].filling_image = [{
                url: ""
            }];
        }
        updatedQuestions[index].filling_image[optId] = {url: value};
    } 


    const onDeleteOption = (index, optId) => {
      try {
        setError([]);
        const updatedQuestions = [...questions];
        const currentOptions = get(updatedQuestions, `[${index}].options`, []);
        const currentAnswers = get(
          updatedQuestions,
          `[${index}].answerSelected`,
          []
        );
        const currentHiglightWord = get(
          updatedQuestions,
          `[${index}].highlightWords`,
          []
        );
        const currentMedia = get(
            updatedQuestions,
            `[${index}].filling_image`,
            []
          );

        // Remove the selected option and its corresponding answer
        updatedQuestions[index].options = currentOptions.filter(
          (_, i) => i !== optId
        );
        updatedQuestions[index].answerSelected = currentAnswers.filter(
          (_, i) => i !== optId
        );
        updatedQuestions[index].highlightWords = currentHiglightWord.filter(
          (_, i) => i !== optId
        );
        updatedQuestions[index].filling_image = currentMedia.filter(
            (_, i) => i !== optId
        );

        // Update the state
        setQuestions(updatedQuestions);
      } catch (error) {
        Sentry.captureException(`573 Error in onDeleteOption: ${error}`);
        console.log(error);
      }
    };

    const makeAnswerSubmitHandler = (index, optId, highlightWords) => {
      try {
        const updatedQuestions = [...questions];
        if (!updatedQuestions[index].answerSelected) {
          updatedQuestions[index].answerSelected = [];
        }
        if (!updatedQuestions[index].options) {
          updatedQuestions[index].options = [];
        }
        if (!updatedQuestions[index].highlightWords) {
          updatedQuestions[index].highlightWords = [];
        }
        
        const normalizedHighlightWords = highlightWords.map(item => ({
          start: item.start ?? null,
          end: item.end ?? null,
          text: item.text,
          id: item.id,
          type: item.type || "highlight",
        }));
        
        updatedQuestions[index].highlightWords[optId] = normalizedHighlightWords;
        const currentHighLightedWord =
          updatedQuestions[index].highlightWords[optId];
        const currentAnswerSelected =
          updatedQuestions[index].answerSelected[optId] || [];
        
        const normalizedCustomAnswers = currentAnswerSelected
          ?.filter((x) => x.type === "custom")
          .map(item => ({
            start: item.start ?? null,
            end: item.end ?? null,
            text: item.text,
            id: item.id,
            type: "custom",
          })) || [];
        
        const deduplicatedCustomAnswers = removeCustomDuplicates(normalizedCustomAnswers);
        const finalAnswer = [...deduplicatedCustomAnswers, ...currentHighLightedWord];
        const result = filterDuplicateWords(finalAnswer);
        
        const normalizedResult = result.map(item => ({
          start: item.start ?? null,
          end: item.end ?? null,
          text: item.text,
          id: item.id,
          type: item.type || "custom",
        }));
        
        updatedQuestions[index].answerSelected[optId] = normalizedResult;
        setQuestions(updatedQuestions);
      } catch (error) {
        Sentry.captureException(`574 Error in makeAnswerSubmitHandler: ${error}`);
        console.log(error);
      }
    };

    const generateAIHandler = async ({ text, index, optId }) => {
        let hide;
        if (text?.length === 0 || !text)
            return showAlert("Please provide option input", "error");
        try {
            setAlertLoading(true, 'Processing your request...');
            const updatedQuestions = [...questions];
            const response = await dispatch(
                handleGetAiOptionForAnswer({
                    option_text: text,
                })
            );
            if (!response?.data) {
                showAlert("AI is not able to generate answer.", "error");
                return;
            }
            if(!Array.isArray(response?.data[0])){
                showAlert("AI is not able to generate answer.", "error");
                return;
            }
            if (!updatedQuestions[index]?.answerSelected) {
                updatedQuestions[index].answerSelected = [];
            }
            const data = updatedQuestions[index].answerSelected[optId];
            
            if (!data) {
                updatedQuestions[index].answerSelected[optId] = [...new Set(response?.data[0])];
            }
            else {
                const mergedData = removeCustomDuplicates([...data, ...response?.data[0]]);
                updatedQuestions[index].answerSelected[optId] = [...new Set(mergedData)];
            }

            setQuestions(updatedQuestions);
        } catch (error) {
            Sentry.captureException(`575 Error in generateAIHandler: ${error}`);
            console.log(error);
            showAlert("AI is not able to generate answer.", "error");
            return;
        } finally {
            setAlertLoading(false, "");
        }
    };

     const onUpdateAnswer = (index, optId, value) => {
       try {
         const updatedQuestions = [...questions];

         if (!updatedQuestions[index]) {
           updatedQuestions[index] = {
             options: [],
             answerSelected: [],
           };
         }

         if (!updatedQuestions[index].answerSelected) {
           updatedQuestions[index].answerSelected = [];
         }

         const normalizedAnswers = value.map(item => ({
          start: item.start ?? null,
          end: item.end ?? null,
          text: item.text,
          id: item.id,
          type: item.type || "custom",
        }));

        const seenCustomTexts = new Set();
        const uniqueAnswers = [];

        normalizedAnswers.forEach(item => {
          const normalizedText = item.text?.toLowerCase()?.trim();
          
          if (item.type === "highlight") {
            uniqueAnswers.push(item);
          } else {
            const hasHighlight = uniqueAnswers.some(
              existing => existing.type === "highlight" && existing.text?.toLowerCase()?.trim() === normalizedText
            );
            
            if (!seenCustomTexts.has(normalizedText) && !hasHighlight) {
              seenCustomTexts.add(normalizedText);
              uniqueAnswers.push(item);
            }
          }
        });

        updatedQuestions[index].answerSelected[optId] = uniqueAnswers;

        if (updatedQuestions[index].highlightWords) {
          const highlightWordsData = updatedQuestions[index].highlightWords[optId];
          const highlightIds = new Set(
            uniqueAnswers
              .filter(answer => answer.type === "highlight")
              .map(answer => answer.id)
          );
          
          const filterHighlightedData = highlightWordsData?.filter((x) => {
            if (x?.type === "highlight" && x?.id !== undefined) {
              return highlightIds.has(x.id);
            }
            return false;
          });
          
          updatedQuestions[index].highlightWords[optId] = filterHighlightedData;
        }
        setQuestions(updatedQuestions);
       } catch (error) {
        Sentry.captureException(`576 Error in onUpdateAnswer: ${error}`);
         console.log(error);
       }
     };

     const toggleDropdown = (optId, isOpen, questionType, questionIndex) => {
       setOptionStates((prev) => ({
         ...prev,
         [optId]: {
           ...prev[optId],
           questionIndex: questionIndex,
           type: questionType,
           dropdownOpen: isOpen,
         },
       }));
     };

     const toggleEditor = (optId, isOpen, questionType, questionIndex) => {
       setOptionStates((prev) => ({
         ...prev,
         [optId]: {
           ...prev[optId],
           type: questionType,
           questionIndex: questionIndex,
           editorOpen: isOpen,
         },
       }));
     };

     const SelectAnswerDropDown = ({
       questionIndex,
       optId,
       optionText,
       questionType,
     }) => ({
       items: [
         {
           key: 'selectAnswer',
           label: (
             <div onClick={() => toggleEditor(optId, true, questionType, questionIndex)}>
               Select Answer from option
             </div>
           )
         },
         {
           key: 'selectRandomAnswer',
           label: (
             <div onClick={() => {
               toggleEditor(optId, false, questionType, questionIndex);
               generateAIHandler({
                 text: optionText,
                 index: questionIndex,
                 optId,
               });
             }}>
               Select Random Answer with AI
             </div>
           )
         }
       ]
     });
     const renderAudioWithMultiChoice = (question, index) => {
         if (renderedGroups.has(question.groupKey)) return null;
         renderedGroups.add(question.groupKey);
         const groupQuestions = questions.filter(q =>
             q.type === 'audioMultipleChoice' && q.groupKey === question.groupKey
         );
         return (
             <RelativeContainer key={question.groupKey}>
                <Row gutter={[24, 24]} style={{ justifyContent: "flex-end", display: "flex" }}>
                    <IconButton onClick={() => {
                        const groupKey = question.groupKey;
                        const indicesToRemove = questions
                            .map((q, idx) => q.groupKey === groupKey ? idx : -1)
                            .filter(idx => idx !== -1)
                            .sort((a, b) => b - a);
                        indicesToRemove.forEach(idx => {
                            removeQuestionError(idx, questions, setError);
                        });
                        setQuestions(prev => {
                            const newQuestions = [...prev].filter(k => k.groupKey != groupKey);
                            return newQuestions;
                        })
                    }} style={{ padding: 0, marginRight: 10 }}>
                        <Delete color="secondary" />
                    </IconButton>
                </Row>
                 <QuestionContainer key={question._uid ?? question.id} >
                     <Detail index={index}>Question {index + 1} of {questions.length}</Detail>
                     <Question style={{ marginTop: 16 }}>
                         <FormControl variant="outlined" className={classes.formControl}>
                             <InputLabel style={{ backgroundColor: 'white', paddingRight: 5 }} id="type">Question Type</InputLabel>
                             <Select
                                 labelId="type"
                                 id="type"
                                 value={question.type}
                                 required
                                 onChange={(v) => {
                                     onChangeQuestionType(v.target.value, index)
                                 }}
                                 label="Type"
                             >
                                 {QUESTION_TYPE_ACTIVITY_NON_NATIVE?.map(v => (<MenuItem key={v.value} value={v.value}>{v.type}</MenuItem>))}
                             </Select>
                         </FormControl>
                     </Question>
                     {/* <Question style={{ marginTop: 6 }}>
                         <Acent inputRef={questionRefs.current[index]} setValue={v => onChangeQuestionData(v, "question", index)} style={{ marginBottom: 5, display: "flex", justifyContent: "flex-end" }} />
                         <TextField
                             id="question"
                             name="question"
                             label={(question?.type === 'filling' || question?.type === 'fillingImage' || question?.type === 'match') ? "Instruction" : "Question"}
                             InputLabelProps={{ shrink: true, required: true }}
                             type="text"
                             inputRef={ref => questionRefs.current[index] = ref}
                             required
                             variant="outlined"
                             onChange={e => {
                                 onChangeQuestionData(e.target.value, "question", index)
                             }}
                             value={question.question}
                         />
                     </Question> */}
                     <Question style={{ marginTop: 6 }}>
                         <AudioMultipleChoice
                             groupKey={question.groupKey}
                             index={index}
                             questions={groupQuestions}
                             setButtonDisabled={setButtonDisabled}
                             setQuestions={(newGroup) => {
                                setQuestions(prev => {
                                    const groupKey = newGroup[0].groupKey;
                                    const startIndex = prev.findIndex(q => q.groupKey === groupKey);
                                    const endIndex = (() => {
                                        const reversedIndex = [...prev].reverse().findIndex(q => q.groupKey === groupKey);
                                        return reversedIndex === -1 ? startIndex : prev.length - reversedIndex;
                                    })();
                                    if (startIndex === -1) return prev;
                                    const newQuestions = [...prev];
                                    newQuestions.splice(startIndex, endIndex - startIndex, ...newGroup);
                                    return newQuestions;
                                });
                             }}
                         />
                 </Question>
                 </QuestionContainer>
             </RelativeContainer>
         );
     }

     useEffect(() => {
        if(questions?.length === 0) {
            setError([]);
        }
     },[questions])

     const showInstructionLabel = useCallback((question) => {
        if(question.type === 'filling' || question.type === 'fillingImage' || question.type === 'match' || question.type === 'audioToImage' || question.type === 'audioEssay' || question.type === 'audioTrueFalse'){
            return "Instruction*";
        }
        return "Question*";
     }, [questions]);

     const renderLabel = (value) => {
        if (!value) return value;
        
        const stateName = getStateNameDisplayForCode(value);
        if (stateName) {
            return stateName;
        }
        
        return value;
     }

     const handleStateStandardChange = (selectedValues, questionIndex, stateIndex, standardObj) => {
        setQuestions(prevQuestions => {
            const updatedQuestions = cloneDeep(prevQuestions);
            if (!updatedQuestions[questionIndex].state_standard) {
                updatedQuestions[questionIndex].state_standard = [];
            }
            if (!Array.isArray(updatedQuestions[questionIndex].state_standard)) {
                updatedQuestions[questionIndex].state_standard = [];
            }
            
            const targetStateName = standardObj?.standard_name || '';
            const existingIndex = updatedQuestions[questionIndex].state_standard.findIndex(s => {
                const sState = typeof s === 'string' ? s : get(s, 'standard_name', '');
                return statesMatch(sState, targetStateName);
            });
            
            if (existingIndex >= 0) {
                updatedQuestions[questionIndex].state_standard[existingIndex] = {
                    ...updatedQuestions[questionIndex].state_standard[existingIndex],
                    standard_name: targetStateName,
                    grade: standardObj?.grade || updatedQuestions[questionIndex].state_standard[existingIndex]?.grade || null,
                    standard: Array.isArray(selectedValues) ? selectedValues : (typeof selectedValues === 'string' && selectedValues ? selectedValues.split(',').map(s => s.trim()).filter(s => s) : [])
                };
            } else {
                const newStateStandard = {
                    standard_name: targetStateName,
                    grade: standardObj?.grade || null,
                    standard: Array.isArray(selectedValues) ? selectedValues : (typeof selectedValues === 'string' && selectedValues ? selectedValues.split(',').map(s => s.trim()).filter(s => s) : [])
                };
                updatedQuestions[questionIndex].state_standard.push(newStateStandard);
            }
            
            return updatedQuestions;
        });
    };

     const renderAudioWithWrittenResponse = (question, index) => {
        if (renderedGroups.has(question.groupKey)) return null;
        renderedGroups.add(question.groupKey);
        const groupQuestions = questions.filter(q =>
            q.type === 'audioEssay' && q.groupKey === question.groupKey
        );
        return (
            <RelativeContainer key={question.groupKey}>
                <Row gutter={[24, 24]} style={{ justifyContent: "flex-end", display: "flex" }}>
                    <IconButton onClick={() => {
                        setQuestions(prev => {
                            const groupKey = question.groupKey;
                            const newQuestions = [...prev].filter(k => k.groupKey != groupKey);
                            return newQuestions;
                        })
                    }} style={{ padding: 0, marginRight: 10 }}>
                        <Delete color="secondary" />
                    </IconButton>
                </Row>
                <QuestionContainer key={question._uid ?? question.id} >
                    <Detail index={index}>Question {index + 1} of {questions.length}</Detail>
                    <Question style={{ marginTop: 16 }}>
                        <FormControl variant="outlined" className={classes.formControl}>
                            <InputLabel style={{ backgroundColor: 'white', paddingRight: 5 }} id="type">Question Type</InputLabel>
                            <Select
                                labelId="type"
                                id="type"
                                value={question.type}
                                required
                                onChange={(v) => {
                                    onChangeQuestionType(v.target.value, index)
                                }}
                                label="Type"
                            >
                                {QUESTION_TYPE_ACTIVITY_NON_NATIVE?.map(v => (<MenuItem key={v.value} value={v.value}>{v.type}</MenuItem>))}
                            </Select>
                        </FormControl>
                    </Question>
                    <Question style={{ marginTop: 6 }}>
                        <AudioWithEssay
                            groupKey={question.groupKey}
                            index={index}
                            questions={groupQuestions}
                            setButtonDisabled={setButtonDisabled}
                            setQuestions={(newGroup) => {
                               setQuestions(prev => {
                                   const groupKey = newGroup[0].groupKey;
                                   const startIndex = prev.findIndex(q => q.groupKey === groupKey);
                                   const endIndex = (() => {
                                       const reversedIndex = [...prev].reverse().findIndex(q => q.groupKey === groupKey);
                                       return reversedIndex === -1 ? startIndex : prev.length - reversedIndex;
                                   })();
                                   if (startIndex === -1) return prev;
                                   const newQuestions = [...prev];
                                   newQuestions.splice(startIndex, endIndex - startIndex, ...newGroup);
                                   return newQuestions;
                               });
                            }}
                        />
                    </Question>
                </QuestionContainer>
            </RelativeContainer>
        );
     }
    return (
     <SentryWrap>
        <>
            {open &&<Drawer
            height="100%"
            destroyOnHidden
            className="assignments-drawer" 
            onClose={onCloseDrawer}
            placement="top"
            open={open}
            keyboard={false}
        >
             
            <Wrapper>
                <Row className="editQuizUpr ebookEditUpr 4444 customImgContainRow" style={{ flexDirection: landscapeOrientation ? 'row' : 'column-reverse' }}>
                    <Col xs={24} sm={12} md={12} style={{ padding: "16px 10px", width: landscapeOrientation ? 'unset' : '100%',maxWidth:'unset' }}>
                        <ImageContiner className='customImgContain'>
                            {(coverTitle || is_soy_story || is_article_level || is_worksheet) ? <label className='customImgTitle'>{coverTitle || displayName || data?.displayName || ''}</label> : null}
                            <Image src={getImages()} alt='' />
                        </ImageContiner>
                    </Col>
                    <Col xs={24} sm={12} md={12} style={{ padding: "16px 16px", paddingBottom: "76px", width: landscapeOrientation ? 'unset' : '100%', maxWidth: 'unset' }}>
                        <Header>{isEditing ? `Edit Assignment` : `Create Assignment`}</Header>
                        <Row justify="start" style={{ marginBottom: 10 }}>
                            {assignedloading?<Typography variant="subtitle2" style={{ display:"flex" , flexDirection:"row", flexWrap: "wrap" }} color="primary"><Loading size={15}/>Please wait while checking assignment assigned status.</Typography>:null}
                            {isAssigned&&!create_new_copy&&!assignedloading?<Typography className='chckAssignTypo' variant="subtitle2" style={{ marginBottom:"10px" }} color="error">{assignmentMessage} <Button variant="contained" color="primary" startIcon={<FileCopy/>} onClick={onSetCopyTrue}>Make a copy</Button></Typography>:null}
                                <Col span={16} sm={16} xs={24}>
                                <Acent inputRef={dispNameRef} setValue={setdisplayName}  style={{ marginBottom: 5 ,  display:"flex" ,justifyContent:"flex-end" }}  />
                                <TextField
                                    id="displayName"
                                    name="displayName"
                                    label="Display Name"
                                    InputLabelProps={{ shrink: true, required: true }}
                                    type="text"
                                    inputRef={dispNameRef}
                                    required
                                    variant="outlined"
                                    onChange={e => {
                                        setdisplayName(e.target.value)
                                    }}
                                    value={displayName}
                                />
                            </Col>
                        </Row>
                        <Row justify="start" style={{ marginBottom: 10 }}>
                        <Col span={12} xs={24} lg={12}>
                            <FormControl variant="outlined" className={classes.formControl} fullWidth>
                                    <InputLabel id="type" style={{ background: 'white' }}>Language for AI Feedback</InputLabel>
                                <Select
                                    labelId="language_feedback"
                                    id="language_feedback"
                                    required={false}
                                    value={languageFeedback || ''}
                                    onChange={(v) => {
                                        setLanguageFeedback(v.target.value)
                                    }}
                                    label="Type"
                                >
                                    <MenuItem value={'ENGLISH'}>English</MenuItem>
                                    <MenuItem value={'SPANISH'}>Spanish</MenuItem>
                                </Select>
                            </FormControl>
                        </Col>
                        </Row>
                        <Row style={{ justifyContent: "space-between", marginBottom: 16 }}>
                            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<Add />}
                                onClick={onAddQuestion}
                                disabled={(isAssigned&&!create_new_copy) || assignedloading || buttonDisabled }
                            >
                                Add Question
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<AutoAwesome />}
                                onClick={onAddQuestionWithAI}
                                disabled={(isAssigned&&!create_new_copy) || assignedloading || buttonDisabled }
                            >
                                Add Question with AI
                            </Button>
                            {questions.length >= 2 && (
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    startIcon={<DragIndicatorIcon />}
                                    onClick={() => {
                                        setReorderList(cloneDeep(questions));
                                        setRearrangeModalOpen(true);
                                    }}
                                    disabled={(isAssigned && !create_new_copy) || assignedloading || buttonDisabled}
                                >
                                    Rearrange Questions
                                </Button>
                            )}
                            </div>
                        </Row>
                        {questions.length > 0 ? <InnerWrapper ref={innerRef} id='previewInner' className='previewFormAssistCstm'>
                            {map(questions, (question, index) => {
                                 if (question.type === 'audioMultipleChoice') {
                                    return renderAudioWithMultiChoice(question, index)
                                 }
                                 else if (question.type === 'audioEssay') {
                                    return renderAudioWithWrittenResponse(question, index)
                                 }
                                return(<RelativeContainer key={question._uid ?? question.id + index}>
                                <Row gutter={[24, 24]} style={{ justifyContent: "flex-end", display: "flex" }}>
                                    <IconButton disabled={Boolean((isAssigned&&!create_new_copy) || assignedloading)} onClick={() => { onDeleteQuestion(question) }} style={{ padding: 0, marginRight: 10 }}>
                                        <Delete color="secondary" />
                                    </IconButton>
                                </Row>
                                <QuestionContainer key={question._uid ?? question.id} >
                                    <Detail index={index}>Question {index + 1} of {questions.length}</Detail>
                                    <Question style={{ marginTop: 16 }}>  
                                        <FormControl variant="outlined" className={classes.formControl}>
                                            <InputLabel style={{ backgroundColor: 'white', paddingRight: 5 }} id="type">Question Type</InputLabel>
                                            <Select
                                                labelId="type"
                                                id="type"
                                                value={question.type}
                                                disabled={(isAssigned&&!create_new_copy) || assignedloading }
                                                required
                                                onChange={(v) => {
                                                    onChangeQuestionType(v.target.value, question)
                                                }}
                                                label="Type"
                                            >
                                                {QUESTION_TYPE_ACTIVITY_NON_NATIVE?.map(v => (<MenuItem key={v.value} value={v.value}>{v.type}</MenuItem>))}
                                            </Select>
                                        </FormControl>
                                    </Question>

                                    <Question>
                                        <label style={{ marginBottom: 0 , fontSize: 12, fontWeight: 400 }}>{showInstructionLabel(question) }</label>
                                        <TextEditor
                                            key={`question-editor-${question._uid ?? question.id}`}
                                            handleChange={(value) => {
                                                onChangeQuestionData(value, "question", question)
                                            }}
                                            placeholder={(question.type !== 'match' && question.type !== 'filling' && question.type !== 'audioToImage') ? 'Type your question here...' : 'Type your instruction here...'}
                                            value={question.question || ''}
                                            autoFocus={false}
                                            disabled={(isAssigned && !create_new_copy) || assignedloading}
                                            containerClassName='question-ebook-text-field'
                                        />
                                    </Question>
                                    {question.type !== 'audioEssay' && question.type !== 'audioMultipleChoice' && question.type !== 'audioTrueFalse' && question.type !== 'audio' && question.type !== 'picture' && question.type !== 'multipleChoice'  && question.type !== 'trueFalse' && question.type !== 'video' && question.type !== 'filling' && question.type !== 'match' && question.type !== 'audioToImage' && question.type !== 'photoCollage' && (
                                    <div className='setupQuesInfo'>
                                       <InfoOutlineIcon /><label>Text below will display the student answer...</label>
                                    </div>
                                    )}
                                    {(() => {
                                        const ebookGradeLevels = getBookData?.grade_levels || [];
                                        const enabledCodesUpper = enabledStateCodes ? enabledStateCodes.map(code => String(code || '').toUpperCase()).filter(Boolean) : [];
                                        
                                        if (Array.isArray(ebookGradeLevels) && ebookGradeLevels.length > 0) {
                                            const hasEnabledStates = Array.isArray(enabledStateCodes) && enabledStateCodes.length > 0;
                                            
                                            const filteredGradeLevels = hasEnabledStates
                                                ? ebookGradeLevels.filter(item => {
                                                    const itemState = get(item, 'state', '');
                                                    const enabledStateNames = enabledStateCodes.map(code => normalizeStateForComparison(code)).filter(Boolean);
                                                    const matches = enabledStateNames.some(enabledName => statesMatch(itemState, enabledName));
                                                    return matches;
                                                })
                                                : (Array.isArray(enabledStateCodes) ? [] : ebookGradeLevels);
                                            
                                            return map(filteredGradeLevels, (gradeLevelItem, stateIndex) => {
                                                const stateCode = get(gradeLevelItem, 'state', '');
                                                const state = getStateNameFromCode(stateCode) || stateCode;
                                                const gradeLevel = get(gradeLevelItem, 'grade_level', '');
                                                
                                                if (!state) {
                                                    return null;
                                                }
                                                
                                                if (Array.isArray(enabledStateCodes)) {
                                                    if (enabledStateCodes.length === 0) {
                                                        return null;
                                                    }
                                                    const enabledStateNames = enabledStateCodes.map(code => normalizeStateForComparison(code)).filter(Boolean);
                                                    const isStateEnabled = enabledStateNames.some(enabledName => statesMatch(state, enabledName));
                                                    if (!isStateEnabled) {
                                                        return null;
                                                    }
                                                }
                                                
                                                const standardObj = {
                                                    standard_name: state,
                                                    grade: gradeLevel
                                                };
                                                
                                                const existingStateStandard = question.state_standard && Array.isArray(question.state_standard) 
                                                    ? question.state_standard.find(s => {
                                                        const sState = typeof s === 'string' ? s : get(s, 'standard_name', '');
                                                        return statesMatch(sState, state);
                                                    })
                                                    : null;
                                                
                                                const standardArray = existingStateStandard 
                                                    ? (Array.isArray(existingStateStandard?.standard) ? existingStateStandard.standard : (existingStateStandard?.standard ? [existingStateStandard.standard] : []))
                                                    : [];
                                                
                                                const filterOptions = standards?.filter((k) => {
                                                    const standardStatus = get(k, 'status', false);
                                                    if (standardStatus !== true) return false;
                                                    const standardState = get(k, 'state', '');
                                                    const standardGradeLevel = get(k, 'grade_level', '');
                                                    
                                                    if (!statesMatch(standardState, state)) return false;
                                                    
                                                    if (enabledStateCodes && enabledStateCodes.length > 0) {
                                                        const enabledStateNames = enabledStateCodes.map(code => normalizeStateForComparison(code)).filter(Boolean);
                                                        const isEnabled = enabledStateNames.some(enabledName => statesMatch(standardState, enabledName));
                                                        if (!isEnabled) return false;
                                                    }
                                                    
                                                    if (!gradeLevel) return true;
                                                    
                                                    const ebookGrades = String(gradeLevel).split(',').map(g => g.trim()).filter(g => g);
                                                    if (ebookGrades.length === 0) return true;
                                                    
                                                    if (!standardGradeLevel) return true;
                                                    
                                                    const standardGrades = String(standardGradeLevel).split(',').map(g => g.trim()).filter(g => g);
                                                    
                                                    return ebookGrades.some(ebookGrade => 
                                                        standardGrades.some(standardGrade => compareGradesForIllinoisCommonCore(ebookGrade, standardGrade, state))
                                                    );
                                                })?.map((k) => k.abbr) || [];
                                                
                                                const selectedStandards = standardArray;
                                                
                                                if (filterOptions.length === 0) {
                                                    return null;
                                                }
                                                                                                
                                                return (
                                                    <div key={stateIndex} style={{ marginBottom: '8px' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                                                            <label style={{ fontSize: 14, fontWeight: 500 }}>{renderLabel(state)}</label>
                                                            {selectedStandards.length > 0 && currentUser?.role === 'teacher' && (
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => {
                                                                        setStandardInfoModal({ 
                                                                            open: true, 
                                                                            standardAbbrs: selectedStandards,
                                                                            stateStandard: [{
                                                                                ...standardObj,
                                                                                standard: selectedStandards
                                                                            }]
                                                                        });
                                                                    }}
                                                                    style={{ padding: '4px' }}
                                                                >
                                                                    <InfoOutlined style={{ fontSize: '18px', color: '#1890ff' }} />
                                                                </IconButton>
                                                            )}
                                                        </div>
                                                        <MultiSelect
                                                            label=""
                                                            InputLabelProps={{ shrink: true }}
                                                            options={filterOptions}
                                                            selectedValue={selectedStandards}
                                                            onSelect={(v) => {
                                                                const selectedArray = typeof v === 'string' ? (v ? v.split(',').map(s => s.trim()).filter(s => s) : []) : (Array.isArray(v) ? v : []);
                                                                handleStateStandardChange(selectedArray, index, stateIndex, standardObj);
                                                            }} 
                                                        />
                                                    </div>
                                                );
                                            });
                                        }
                                        
                                        return null;
                                    })()}
                                                                        
                                    {question.type === 'picture' && (
                                            <PictureAssignment 
                                             source={question.pictures}
                                             additionalImages={question.additionalPictures || []}
                                             handlePicture={(v) => {
                                                onChangeQuestionData(v, "pictures", index)
                                            }}
                                             handleAdditionalPictures={(v) => {
                                                onChangeQuestionData(v, "additionalPictures", index)
                                            }}
                                            style={{marginTop: question.pictures ? (window.innerWidth >= 1024 ? "130px" : "85px") : "" }}
                                            imageClassName={`assignment-image ${isTablate ? "assignmentTabImg" : ""}`} 
                                            containerClassName="assignment-ebook"
                                            setButtonDisabled={(value)=> setButtonDisabled(value)}
                                            disabled={(isAssigned && !create_new_copy) || assignedloading}
                                            />
                                        )}
                                    <Content>
                                        {question.type === 'email' && (
                                            <Row gutter={[0, 24]}>
                                                <Col span={24}>
                                                    <TextEditor
                                                        handleChange={() => { }}
                                                        value={''}
                                                        autoFocus={false}
                                                        disabled={true}
                                                        containerClassName='question-ebook-text-field'
                                                    />
                                                </Col>
                                            </Row>
                                        )}
                                        {question.type === 'essay' && (
                                            <Row gutter={[0, 24]}>
                                                <Col span={24}>
                                                    <TextEditor
                                                        handleChange={() => { }}
                                                        value={''}
                                                        autoFocus={false}
                                                        disabled={true}
                                                        containerClassName='question-ebook-text-field'
                                                    />
                                                </Col>
                                            </Row>
                                        )}
                                        {question.type === 'multipleChoice' && (
                                            <>
                                                <FormControl variant="outlined" className={classes.formControl} style={{ marginBottom: 16 }}>
                                                    <InputLabel id="type" style={{ backgroundColor: "#fff" }}>Number of options</InputLabel>
                                                    <Select
                                                        labelId="level"
                                                        id="level"
                                                        required={false}
                                                        disabled={(isAssigned && !create_new_copy) || assignedloading}
                                                        value={get(question, "options.length", 4)}
                                                        onChange={(v) => {
                                                            onChangeOptionsLength(index, v.target.value)
                                                        }}
                                                        label="Type"
                                                    >
                                                        <MenuItem value={2}>2</MenuItem>
                                                        <MenuItem value={3}>3</MenuItem>
                                                        <MenuItem value={4}>4</MenuItem>
                                                        <MenuItem value={5}>5</MenuItem>
                                                        <MenuItem value={6}>6</MenuItem>
                                                        <MenuItem value={7}>7</MenuItem>
                                                        <MenuItem value={8}>8</MenuItem>
                                                        <MenuItem value={9}>9</MenuItem>
                                                        <MenuItem value={10}>10</MenuItem>
                                                    </Select>
                                                </FormControl>
                                                {map(get(question, "options", ['', '', '', '']), (option, optId) => (
                                                    <Row key={optId} style={{ marginBottom: '8px' }}>
                                                        <RadioGroup style={{ display: "flex", flexDirection: "row", width: "100%" }} aria-label="options"
                                                            name={`options-${index}`}
                                                            value={`${question.answer}`}
                                                            onChange={(e) => { onChangeQuestionData(e.target.value, "answer", index) }}>
                                                            <Row style={{ width: "100%" }}>
                                                                <RadioColumn span={2}>
                                                                    <FormControlLabel disabled={(isAssigned && !create_new_copy) || assignedloading} value={`${optId}`} checked={optId == question.answer} control={<Radio />} />
                                                                </RadioColumn>
                                                                <Col span={22}>
                                                                    <Acent inputRef={optionRefs.current[`${index}-${optId}`]} setValue={v => onchangeOption(index, optId, v)} style={{ marginBottom: 5, display: "flex", justifyContent: "flex-end" }} />
                                                                    <TextField
                                                                        id={`question${index + optId}`}
                                                                        name="options"
                                                                        label={`option ${LABEL[optId]}`}
                                                                        InputLabelProps={{ shrink: true, required: true }}
                                                                        // disabled={isAssigned || assignedloading}
                                                                        type="text"
                                                                        required
                                                                        variant="outlined"
                                                                        inputRef={ref => optionRefs.current[`${index}-${optId}`] = ref}
                                                                        onChange={e => {
                                                                            onchangeOption(index, optId, e.target.value)
                                                                        }}
                                                                        value={option}
                                                                    />

                                                                </Col>

                                                            </Row>


                                                        </RadioGroup>

                                                    </Row>
                                                ))}
                                            </>
                                        )}
                                        {question.type === 'multipleResponse' && (
                                            <>
                                                <FormControl variant="outlined" className={classes.formControl} style={{ marginBottom: 16 }}>
                                                    <InputLabel id="type" style={{ backgroundColor: "#fff" }}>Number of options</InputLabel>
                                                    <Select
                                                        labelId="level"
                                                        id="level"
                                                        required={false}
                                                        disabled={(isAssigned && !create_new_copy) || assignedloading}
                                                        value={get(question, "options.length", 4)}
                                                        onChange={(v) => {
                                                            onChangeOptionsLength(index, v.target.value)
                                                        }}
                                                        label="Type"
                                                    >
                                                        <MenuItem value={2}>2</MenuItem>
                                                        <MenuItem value={3}>3</MenuItem>
                                                        <MenuItem value={4}>4</MenuItem>
                                                        <MenuItem value={5}>5</MenuItem>
                                                        <MenuItem value={6}>6</MenuItem>
                                                        <MenuItem value={7}>7</MenuItem>
                                                        <MenuItem value={8}>8</MenuItem>
                                                        <MenuItem value={9}>9</MenuItem>
                                                        <MenuItem value={10}>10</MenuItem>
                                                    </Select>
                                                </FormControl>
                                                {map(get(question, "options", ['', '', '', '']), (option, optId) => (
                                                    <Row key={optId} style={{ marginBottom: '8px' }}>
                                                        <Row style={{ width: "100%" }}>
                                                            <Col span={2} style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '22px' }}>
                                                                <FormControlLabel 
                                                                    disabled={(isAssigned && !create_new_copy) || assignedloading}
                                                                    control={
                                                                        <Checkbox 
                                                                            checked={Array.isArray(question.answer) && question.answer.includes(optId.toString())}
                                                                            onChange={(e) => {
                                                                                const currentAnswers = Array.isArray(question.answer) ? [...question.answer] : [];
                                                                                if (e.target.checked) {
                                                                                    currentAnswers.push(optId.toString());
                                                                                } else {
                                                                                    currentAnswers.splice(currentAnswers.indexOf(optId.toString()), 1);
                                                                                }
                                                                                onChangeQuestionData(currentAnswers, "answer", index);
                                                                            }}
                                                                        />
                                                                    }
                                                                    label=""
                                                                />
                                                            </Col>
                                                            <Col span={22}>
                                                                <Acent inputRef={optionRefs.current[`${index}-${optId}`]} setValue={v => onchangeOption(index, optId, v)} style={{ marginBottom: 5, display: "flex", justifyContent: "flex-end" }} />
                                                                <TextField
                                                                    id={`question${index + optId}`}
                                                                    name="options"
                                                                    label={`option ${LABEL[optId]}`}
                                                                    InputLabelProps={{ shrink: true, required: true }}
                                                                    type="text"
                                                                    required
                                                                    inputRef={ref => optionRefs.current[`${index}-${optId}`] = ref}
                                                                    variant="outlined"
                                                                    onChange={e => {
                                                                        onchangeOption(index, optId, e.target.value)
                                                                    }}
                                                                    value={option}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Row>
                                                ))}
                                            </>
                                        )}
                                        {(question.type === 'audio' || question.type === 'audioEssay' || question.type == 'audioTrueFalse' || question.type === 'audioToImage') && (
                                            <>
                                               {question.type != 'audioTrueFalse' && question.type != 'audioEssay' && question.type != 'audioToImage' ? <Question style={{ marginBottom: 16 }}>
                                                    <FormControl variant="outlined" className={classes.formControl}>
                                                        <InputLabel id="durations">Time</InputLabel>
                                                        <Select
                                                            labelId="durations"
                                                            id="durations"
                                                            value={question.duration || '60'}
                                                            required
                                                            disabled={(isAssigned && !create_new_copy) || assignedloading}
                                                            onChange={(v) => {
                                                                onChangeQuestionData(v.target.value, "duration", index)
                                                            }}
                                                            label="Type"
                                                        >
                                                            {DURATIONS.map(v => (<MenuItem value={v.value}>{v.label}</MenuItem>))}
                                                        </Select>
                                                    </FormControl>
                                                </Question>:null}
                                                <Question style={{ marginBottom: 16 }}>
                                                    <AudioRecorder
                                                        handleAudio={(v) => {
                                                            onChangeQuestionData(v, "audio", index)
                                                            trenacriptAudio(v)
                                                        }}
                                                        index={index}
                                                        currentSubmission={{}}
                                                        refresh={() => { }}
                                                        source={question.audio}
                                                        hasSaveButton
                                                        message={`Record a question`}
                                                        setButtonDisabled={(value) => setButtonDisabled(value)}
                                                    />
                                                </Question>
                                                <Question style={{ marginBottom: 16, textAlign: "center" }}>
                                                    OR
                                                </Question>
                                                <AudioPicker
                                                    message={"Upload a audio file for question..."}
                                                    onChange={v => {
                                                        onChangeQuestionData(v, "audio", index)
                                                        trenacriptAudio(v)
                                                    }}
                                                    setButtonDisabled={(value) => setButtonDisabled(value)}
                                                />
                                                {question.type !== 'audioTrueFalse' && question.type !== 'audioToImage' && (
                                                    <div className='setupQuesInfo' style={{ marginBottom: 10 , marginTop: "0px !important" }}><InfoOutlineIcon /><label>Text below will display the student answer...</label></div>
                                                )}
                                                {question.type === 'audio' && (
                                                    <AudioRecorder
                                                        maxTime={question.duration || 20}
                                                        handleAudio={() => { }}
                                                        index={index}
                                                        currentSubmission={{}}
                                                        refresh={() => { }}
                                                        isPreview
                                                    />
                                                )}
                                                {question.type === 'audioEssay' && (
                                                    <Row gutter={[0, 24]}>
                                                        <Col span={24}>
                                                            <TextEditor
                                                                handleChange={() => { }}
                                                                value={''}
                                                                autoFocus={false}
                                                                disabled={true}
                                                                containerClassName='question-ebook-text-field'
                                                            />
                                                        </Col>
                                                    </Row>
                                                )}
                                                {question.type === 'audioToImage' && (
                                                    <Row gutter={[0, 24]}>
                                                        <Col span={24}>
                                                            <StyledFormControl>
                                                                <StyledInputLabel id="type">
                                                                    Student can upload up to {question.studentCanUploadImages || 6} images.
                                                                </StyledInputLabel>
                                                                <Select
                                                                    labelId="type"
                                                                    id="type"
                                                                    value={question.studentCanUploadImages || 6}
                                                                    required
                                                                    onChange={(v) => {
                                                                        onChangeQuestionData(v.target.value, 'studentCanUploadImages', index);
                                                                    }}
                                                                    label="Select Collage Count"
                                                                >
                                                                    {imageUpload?.map((v) => (
                                                                        <MenuItem key={v.value} value={v.value}>
                                                                            {v.value}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </StyledFormControl>
                                                             <div className='setupQuesInfo' style={{ marginBottom: 10 , marginTop: "0px !important" }}><InfoOutlineIcon /><label>Text below will display the student answer...</label></div>
                                                            <PictureAssignment
                                                                disabled={true}
                                                                source={question.image}
                                                                handlePicture={(v) => {
                                                                    onChangeQuestionData(v, "image", index)
                                                                }}
                                                            />
                                                        </Col>
                                                    </Row>
                                                )}
                                                {question.type === 'audioTrueFalse' && (
                                                    map(get(question, "options", ['Cierto', 'Falso']), (option, optId) => (
                                                        <Row key={optId} style={{ marginBottom: '8px' }}>
                                                            <RadioGroup style={{ display: "flex", flexDirection: "row", width: "100%" }} aria-label="options" name={`options-${index}`} value={`${question.answer}`} onChange={(e) => { onChangeQuestionData(parseInt(e.target.value), "answer", index) }}>
                                                                <Row style={{ width: "100%" }}>
                                                                    <RadioColumn span={2}>
                                                                        <FormControlLabel value={`${optId}`} checked={optId == question.answer} control={<Radio />} />
                                                                    </RadioColumn>
                                                                    <Col span={22}>
                                                                        <Acent inputRef={optionRefs.current[`${index}-${optId}`]} setValue={v => onchangeOption(index, optId, v, 'audioTrueFalse')} style={{ marginBottom: 5, display: "flex", justifyContent: "flex-end" }} />
                                                                        <TextField
                                                                            id={`question${index + optId}`}
                                                                            name="options"
                                                                            label={`option ${LABEL[optId]}`}
                                                                            InputLabelProps={{ shrink: true, required: true }}
                                                                            type="text"
                                                                            required
                                                                            inputRef={ref => optionRefs.current[`${index}-${optId}`] = ref}
                                                                            variant="outlined"
                                                                            onChange={e => {
                                                                                onchangeOption(index, optId, e.target.value, 'audioTrueFalse')
                                                                            }}
                                                                            value={option}
                                                                        />

                                                                    </Col>

                                                                </Row>


                                                            </RadioGroup>

                                                        </Row>
                                                    ))
                                                )}
                                            </>
                                        )}
                                        {question.type === 'video' && (
                                            <AssignmentVideo
                                                states={{ index, question, isAssigned, create_new_copy, assignedloading }}
                                                funcObj={{
                                                    onChangeQuestionData,
                                                    setButtonDisabled,
                                                    trenacriptAudio
                                                }}

                                            />
                                        )}
                                        {question?.type === 'match' && (
                                            // Match Making for Teacher
                                            <MatchMaking
                                                disabled={Boolean((isAssigned && !create_new_copy) || assignedloading)}
                                                index={index}
                                                question={question}
                                                optionRefs={optionRefs}
                                                onAddMoreOption={onAddMatchOption}
                                                onChangeType={onChangeQuestionData}
                                                onDeleteMatchOption={onDeleteMatchOption}
                                                onchangeOptionMatch={onchangeOptionMatch}
                                                setButtonDisabled={(value) => setButtonDisabled(value)}
                                                isEditing={isEditing}
                                                onMediaUploaded={trenacriptAudio}
                                            />
                                        )}
                                        {(question.type === 'filling' || question.type === 'fillingImage') && (
                                            <>
                                                <AssignmentFormFillInBlanksComp
                                                    refs={{
                                                        answerRefs,
                                                        optionRefs
                                                    }}
                                                    states={{
                                                        index,
                                                        question,
                                                        questions,
                                                        optionStates,
                                                        isEditing
                                                    }}
                                                    funcObj={{
                                                        onAddOption,
                                                        onchangeOptionFilling,
                                                        onDeleteOption,
                                                        handleInputChange,
                                                        onUpdateAnswer,
                                                        getInputValue,
                                                        makeAnswerSubmitHandler,
                                                        handlePictureFilling,
                                                        toggleDropdown,
                                                        toggleEditor,
                                                        setButtonDisabled,
                                                        onChangeQuestionData,
                                                        onMediaUploaded: trenacriptAudio,
                                                    }}
                                                    SelectAnswerDropDown={SelectAnswerDropDown}
                                                    disabled={Boolean((isAssigned && !create_new_copy) || assignedloading)}
                                                />
                                            </>
                                        )}
                                        {question.type === 'twoMinAudio' && (
                                            <>
                                                <AudioRecorder
                                                    maxTime={120}
                                                    handleAudio={() => { }}
                                                    refresh={() => { }}
                                                    isPreview
                                                    setButtonDisabled={(value) => setButtonDisabled(value)}
                                                />
                                            </>
                                        )}
                                        {question.type === 'trueFalse' && (
                                            <>
                                                {map(get(question, "options", ['Cierto', 'Falso']), (option, optId) => {
                                                    return (
                                                        <Row key={optId} style={{ marginBottom: '8px' }}>
                                                            <RadioGroup style={{ display: "flex", flexDirection: "row", width: "100%" }} aria-label="options"
                                                                name={`options-${index}`}
                                                                value={`${question.answer}`}
                                                                onChange={(e) => { onChangeQuestionData(e.target.value, "answer", index) }}>
                                                                <Row style={{ width: "100%" }}>
                                                                    <RadioColumn span={2}>
                                                                        <FormControlLabel disabled={(isAssigned && !create_new_copy) || assignedloading} value={`${optId}`} checked={optId == question.answer} control={<Radio />} />
                                                                    </RadioColumn>
                                                                    <Col span={22}>
                                                                        <Acent inputRef={optionRefs.current[`${index}-${optId}`]} setValue={v => onchangeOption(index, optId, v, 'trueFalse')} style={{ marginBottom: 5, display: "flex", justifyContent: "flex-end" }} />
                                                                        <TextField
                                                                            id={`question${index + optId}`}
                                                                            name="options"
                                                                            label={`option ${LABEL[optId]}`}
                                                                            InputLabelProps={{ shrink: true, required: true }}
                                                                            type="text"
                                                                            required
                                                                            inputRef={ref => optionRefs.current[`${index}-${optId}`] = ref}
                                                                            variant="outlined"
                                                                            onChange={e => {
                                                                                onchangeOption(index, optId, e.target.value, 'trueFalse')
                                                                            }}
                                                                            value={option}
                                                                        />

                                                                    </Col>

                                                                </Row>


                                                            </RadioGroup>

                                                        </Row>
                                                    )
                                                })}
                                            </>
                                        )}
                                        {question.type === 'picture' && (
                                           <PictureAssignmentType 
                                            states={{question,index}}
                                            funcObj={{onChangeQuestionData}}
                                           />
                                        )}
                                        
                                        {question?.type === "photoCollage" && 
                                          <>
                                            <AssignmentPhotoCollage states={{ index, question, isPreview: true, selectData: true, collageLength: question?.collageLength, frameCollage: question?.collageFrame,showFullPreview:true  }} funcObj={{ onChangeQuestionData }} />
                                            </>
                                        }
                                    </Content>
                                </QuestionContainer>
                            </RelativeContainer>)})}
                        </InnerWrapper> : null}
                        {errors.length > 0 ? <Row style={{ marginTop: 10, marginRight: 0, marginLeft: 0, flexDirection: "column", display: "flex" }}>
                            {errors.map(v => (<Typography variant="subtitle2" key={v.type} style={{ whiteSpace: "pre-wrap" }} color="error">
                                * {get(v, "message")}
                            </Typography>))}
                        </Row> : null}
                        <Row gutter={[24, 24]} style={{ marginTop: 10, marginRight: 0, marginLeft: 0 }}>
                            <Button fullWidth
                                onClick={onSubmit}
                                disabled={isExamOrStandardExam || Boolean(questions.length == 0 || (!displayName || displayName.length == 0) || loading || assignedloading || ((isAssigned&&!create_new_copy)&&!get(data, "id")&&get(data, "cloneId"))) || (isAssigned && !create_new_copy && data.type !='custom' ) || (isAssigned&&!create_new_copy) || buttonDisabled}
                                variant="contained"
                                color="primary">
                                {loading ? <Loading white size={15} /> : null} {isEditing||get(data, "cloneId") ? `${create_new_copy?"Create a copy":"Update"}` : "Create"}
                            </Button>
                        </Row>
                    </Col>
                </Row>
            </Wrapper>
            </Drawer>}
           {open && <AssignmentAiSection
                data={bookContentData}
                assignmentAiModal={assignmentAiSectionModal}
                setassignmentAiModal={setAssignmentAiSectionModal}
                page={pageId}
                chapter={bookId}
                fromResource={formResource}
                from={from}
                BALCON_PAGES={balconPages}
                uniqueKeyAssignmentAi={`assignmentAiSectionModal`}
                onAddQuestionsToAssignment={(aiQuestions) => {
                    setQuestions(prev => [...prev, ...aiQuestions]);
                    scrollToBottom()
                }}
            />}
            <Modal
                title="Rearrange Questions"
                open={rearrangeModalOpen}
                onCancel={() => setRearrangeModalOpen(false)}
                width={520}
                zIndex={1100}
                footer={[
                    <Button key="cancel" onClick={() => setRearrangeModalOpen(false)}>
                        Cancel
                    </Button>,
                    <Button
                        key="done"
                        type="primary"
                        onClick={() => {
                            const reorderedWithIds = reorderList.map((q, index) => ({
                                ...q,
                                id: index + 1,
                            }));
                            setQuestions(reorderedWithIds);
                            questionsRef.current = reorderedWithIds;
                            setRearrangeModalOpen(false);
                        }}
                    >
                        Done
                    </Button>,
                ]}
            >
                {reorderList.length > 0 && (
                    <RearrangeQuestionsList
                        reorderList={reorderList}
                        setReorderList={setReorderList}
                    />
                )}
            </Modal>
            <StandardsModal
                open={standardInfoModal.open}
                onClose={() => {
                    setStandardInfoModal({ open: false, standardAbbrs: [], stateStandard: null });
                }}
                standardAbbrs={standardInfoModal.standardAbbrs}
                stateStandard={standardInfoModal.stateStandard}
                standards={standards}
                enabledStateCodes={enabledStateCodes}
                userRole={currentUser?.role}
            />
        </>
    </SentryWrap>
    );
};

const mapStateToProps = state => ({
    currentClass: state.currentClass,
    userClasses: state.userClasses,
    booksAllList: state.booksAllList,
    currentUser: state.currentUser
});


export default connect(mapStateToProps, null)(AssignmentForm);